// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AlertsAlertWebhookData, AlertsAlertWebhookResponse, AlertsCriticalAlertWebhookData, AlertsCriticalAlertWebhookResponse, AlertsGetAlertStatusResponse, CommandsReadCommandsData, CommandsReadCommandsResponse, CommandsReadCommandData, CommandsReadCommandResponse, CommandsDeleteCommandData, CommandsDeleteCommandResponse, GetMetricsResponse, HealthCheckResponse, GetCircuitBreakersResponse, ResetCircuitBreakerData, ResetCircuitBreakerResponse, DemoBannerStatusResponse, DemoCreateVisitorSessionResponse, DemoSelfProvisionReaderData, DemoSelfProvisionReaderResponse, DppResolvePublicPassportData, DppResolvePublicPassportResponse, DppPublicBindTagTemplateData, DppPublicBindTagTemplateResponse, DppRecordsUpsertDppRecordBySkuData, DppRecordsUpsertDppRecordBySkuResponse, DppRecordsListDppRecordsData, DppRecordsListDppRecordsResponse, DppRecordsCreateDppRecordData, DppRecordsCreateDppRecordResponse, DppRecordsReadDppRecordData, DppRecordsReadDppRecordResponse, DppRecordsUpdateDppRecordData, DppRecordsUpdateDppRecordResponse, DppRecordsDeleteDppRecordData, DppRecordsDeleteDppRecordResponse, ItemsReadItemsData, ItemsReadItemsResponse, ItemsCreateItemData, ItemsCreateItemResponse, ItemsReadItemData, ItemsReadItemResponse, ItemsUpdateItemData, ItemsUpdateItemResponse, ItemsDeleteItemData, ItemsDeleteItemResponse, LicensesRequestTrialData, LicensesRequestTrialResponse, LicensesValidateLicenseData, LicensesValidateLicenseResponse, LicensesRevokeLicenseData, LicensesRevokeLicenseResponse, LicensesSyncLicenseData, LicensesSyncLicenseResponse, LicensesRequestLicenseData, LicensesRequestLicenseResponse, LoginLoginAccessTokenData, LoginLoginAccessTokenResponse, LoginLogin2SvVerifyData, LoginLogin2SvVerifyResponse, LoginLogoutResponse, LoginTestTokenResponse, LoginRefreshTokenResponse, ManufacturersListManufacturersData, ManufacturersListManufacturersResponse, ManufacturersCreateManufacturerData, ManufacturersCreateManufacturerResponse, ManufacturersReadManufacturerData, ManufacturersReadManufacturerResponse, ManufacturersUpdateManufacturerData, ManufacturersUpdateManufacturerResponse, ManufacturersDeleteManufacturerData, ManufacturersDeleteManufacturerResponse, OrganisationsReadOrganisationsData, OrganisationsReadOrganisationsResponse, OrganisationsCreateOrganisationData, OrganisationsCreateOrganisationResponse, OrganisationsReadOrganisationData, OrganisationsReadOrganisationResponse, OrganisationsUpdateOrganisationData, OrganisationsUpdateOrganisationResponse, OrganisationsDeleteOrganisationData, OrganisationsDeleteOrganisationResponse, OrganisationsUploadOrganisationLogoData, OrganisationsUploadOrganisationLogoResponse, OrganisationsDeleteOrganisationLogoData, OrganisationsDeleteOrganisationLogoResponse, OrganisationsGetOrganizationPermissionsData, OrganisationsGetOrganizationPermissionsResponse, OrganisationsCreatePermissionData, OrganisationsCreatePermissionResponse, OrganisationsDeletePermissionData, OrganisationsDeletePermissionResponse, OrganisationsSetupUserPermissionsData, OrganisationsSetupUserPermissionsResponse, UsersReadOrganizationUsersData, UsersReadOrganizationUsersResponse, ReadersReadOrganizationReadersData, ReadersReadOrganizationReadersResponse, ReadersCreateOrganizationReaderData, ReadersCreateOrganizationReaderResponse, ReadersReadOrganizationReadersPaginatedData, ReadersReadOrganizationReadersPaginatedResponse, ReadersReadOrganizationReaderData, ReadersReadOrganizationReaderResponse, ReadersOrganizationReaderInventoryData, ReadersOrganizationReaderInventoryResponse, ReadersOrganizationReaderStartData, ReadersOrganizationReaderStartResponse, ReadersOrganizationReaderStopData, ReadersOrganizationReaderStopResponse, ReadersOrganizationReaderGetStatusData, ReadersOrganizationReaderGetStatusResponse, ReadersOrganizationReaderGetVersionData, ReadersOrganizationReaderGetVersionResponse, ReadersOrganizationReaderGetConfigData, ReadersOrganizationReaderGetConfigResponse, ReadersOrganizationReaderGetQdatConfigData, ReadersOrganizationReaderGetQdatConfigResponse, ReadersOrganizationReaderSetQdatConfigData, ReadersOrganizationReaderSetQdatConfigResponse, ReadersOrganizationReaderGetCommandsData, ReadersOrganizationReaderGetCommandsResponse, ReadersOrganizationReaderGetModeData, ReadersOrganizationReaderGetModeResponse, ReadersOrganizationReaderRebootData, ReadersOrganizationReaderRebootResponse, TagsReadOrganizationTagsData, TagsReadOrganizationTagsResponse, TagsCreateOrganizationTagData, TagsCreateOrganizationTagResponse, TagsListOrganizationTagTrashData, TagsListOrganizationTagTrashResponse, TagsReadOrganizationTagsPaginatedData, TagsReadOrganizationTagsPaginatedResponse, TagsReadOrganizationTagsMapData, TagsReadOrganizationTagsMapResponse, TagsListDistinctTagCategoriesData, TagsListDistinctTagCategoriesResponse, TagsListDistinctTagSkusData, TagsListDistinctTagSkusResponse, TagsGetOrganizationRecentActivityData, TagsGetOrganizationRecentActivityResponse, TagsGetOrganizationEventsPaginatedData, TagsGetOrganizationEventsPaginatedResponse, TagsReadOrganizationTagEventsData, TagsReadOrganizationTagEventsResponse, TagsReadOrganizationTagBarcodeScansData, TagsReadOrganizationTagBarcodeScansResponse, TagsReadOrganizationTagMultimodalScansData, TagsReadOrganizationTagMultimodalScansResponse, TagsReadOrganizationMultimodalScanData, TagsReadOrganizationMultimodalScanResponse, TagsReadOrganizationTagData, TagsReadOrganizationTagResponse, TagsUpdateOrganizationTagData, TagsUpdateOrganizationTagResponse, TagsDeleteOrganizationTagData, TagsDeleteOrganizationTagResponse, TagsUploadTagImageData, TagsUploadTagImageResponse, TagsDeleteTagImageData, TagsDeleteTagImageResponse, TagsBulkDeleteOrganizationTagsData, TagsBulkDeleteOrganizationTagsResponse, TagsRestoreOrganizationTagData, TagsRestoreOrganizationTagResponse, TagsBulkRestoreOrganizationTagsData, TagsBulkRestoreOrganizationTagsResponse, TagsPermanentlyDeleteOrganizationTagData, TagsPermanentlyDeleteOrganizationTagResponse, TagsGetOrganizationTagFirstReadingData, TagsGetOrganizationTagFirstReadingResponse, TagTemplatesReadOrganizationTemplatesData, TagTemplatesReadOrganizationTemplatesResponse, TagTemplatesCreateOrganizationTemplateData, TagTemplatesCreateOrganizationTemplateResponse, TagTemplatesListObservedChipTypesData, TagTemplatesListObservedChipTypesResponse, TagTemplatesGetTagCatalogData, TagTemplatesGetTagCatalogResponse, TagTemplatesReadOrganizationTemplateData, TagTemplatesReadOrganizationTemplateResponse, TagTemplatesUpdateOrganizationTemplateData, TagTemplatesUpdateOrganizationTemplateResponse, TagTemplatesDeleteOrganizationTemplateData, TagTemplatesDeleteOrganizationTemplateResponse, PassportTemplatesGetDppClusterInfoInlineData, PassportTemplatesGetDppClusterInfoInlineResponse, PassportTemplatesListPassportTemplatesData, PassportTemplatesListPassportTemplatesResponse, PassportTemplatesCreatePassportTemplateData, PassportTemplatesCreatePassportTemplateResponse, PassportTemplatesReadPassportTemplateData, PassportTemplatesReadPassportTemplateResponse, PassportTemplatesUpdatePassportTemplateData, PassportTemplatesUpdatePassportTemplateResponse, PassportTemplatesDeletePassportTemplateData, PassportTemplatesDeletePassportTemplateResponse, RepresentativesListRepresentativesData, RepresentativesListRepresentativesResponse, RepresentativesCreateRepresentativeData, RepresentativesCreateRepresentativeResponse, RepresentativesReadRepresentativeData, RepresentativesReadRepresentativeResponse, RepresentativesUpdateRepresentativeData, RepresentativesUpdateRepresentativeResponse, RepresentativesDeleteRepresentativeData, RepresentativesDeleteRepresentativeResponse, TagCategoriesListTagCategoriesData, TagCategoriesListTagCategoriesResponse, TagCategoriesCreateTagCategoryData, TagCategoriesCreateTagCategoryResponse, TagCategoriesReadTagCategoryData, TagCategoriesReadTagCategoryResponse, TagCategoriesUpdateTagCategoryData, TagCategoriesUpdateTagCategoryResponse, TagCategoriesDeleteTagCategoryData, TagCategoriesDeleteTagCategoryResponse, TagSkUsListTagSkusData, TagSkUsListTagSkusResponse, TagSkUsCreateTagSkuData, TagSkUsCreateTagSkuResponse, TagSkUsReadTagSkuData, TagSkUsReadTagSkuResponse, TagSkUsUpdateTagSkuData, TagSkUsUpdateTagSkuResponse, TagSkUsDeleteTagSkuData, TagSkUsDeleteTagSkuResponse, TagsSetTagPassportBindingData, TagsSetTagPassportBindingResponse, ReadersReadReadersData, ReadersReadReadersResponse, ReadersCreateReaderData, ReadersCreateReaderResponse, ReadersReadReadersPaginatedData, ReadersReadReadersPaginatedResponse, ReadersReadReaderData, ReadersReadReaderResponse, ReadersUpdateReaderData, ReadersUpdateReaderResponse, ReadersDeleteReaderData, ReadersDeleteReaderResponse, ReadersReaderInventoryData, ReadersReaderInventoryResponse, ReadersGenerateMqttCredentialsData, ReadersGenerateMqttCredentialsResponse, ReadersRevokeMqttCredentialsData, ReadersRevokeMqttCredentialsResponse, ReadersRegenerateMqttCredentialsData, ReadersRegenerateMqttCredentialsResponse, ReadersGetMqttCredentialStatusData, ReadersGetMqttCredentialStatusResponse, ReadersReaderStopData, ReadersReaderStopResponse, RfidExecuteRawRfidCommandData, RfidExecuteRawRfidCommandResponse, RfidCreateCommandAliasData, RfidCreateCommandAliasResponse, RfidListCommandAliasesData, RfidListCommandAliasesResponse, RfidDeleteCommandAliasData, RfidDeleteCommandAliasResponse, SvTwoSvStatusResponse, SvTwoSvSetupResponse, SvTwoSvEnableData, SvTwoSvEnableResponse, SvTwoSvDisableData, SvTwoSvDisableResponse, TagsReadTagsData, TagsReadTagsResponse, TagsCreateTagData, TagsCreateTagResponse, TagsReadTagsPaginatedData, TagsReadTagsPaginatedResponse, TagsReadTagData, TagsReadTagResponse, TagsUpdateTagData, TagsUpdateTagResponse, TagsDeleteTagData, TagsDeleteTagResponse, TagsReadTagTemplatesData, TagsReadTagTemplatesResponse, TagsCreateTagTemplateData, TagsCreateTagTemplateResponse, TagsReadTagTemplateData, TagsReadTagTemplateResponse, TagsUpdateTagTemplateData, TagsUpdateTagTemplateResponse, TagsDeleteTagTemplateData, TagsDeleteTagTemplateResponse, TagsCreateTagFromTemplateData, TagsCreateTagFromTemplateResponse, TagsReadTagReadingsData, TagsReadTagReadingsResponse, TagsCreateTagReadingData, TagsCreateTagReadingResponse, TagsCountTagReadingsData, TagsCountTagReadingsResponse, TagsReadTagEventsData, TagsReadTagEventsResponse, TagsCreateTagEventData, TagsCreateTagEventResponse, TagsReadTagScanTelemetryData, TagsReadTagScanTelemetryResponse, TagsReadTagAlertsData, TagsReadTagAlertsResponse, TagsAcknowledgeTagAlertData, TagsAcknowledgeTagAlertResponse, TagsReadActiveAlertsData, TagsReadActiveAlertsResponse, TagsFetchTagInfoData, TagsFetchTagInfoResponse, TagsFetchTagDataData, TagsFetchTagDataResponse, TagsArmTagData, TagsArmTagResponse, TagsRecalculateReadingCountsResponse, UploadsServeUploadData, UploadsServeUploadResponse, UsersReadUserMeResponse, UsersDeleteUserMeResponse, UsersUpdateUserMeData, UsersUpdateUserMeResponse, UsersUpdatePasswordMeData, UsersUpdatePasswordMeResponse, UsersRegisterUserData, UsersRegisterUserResponse, UsersCreateUserData, UsersCreateUserResponse, UsersReadUsersData, UsersReadUsersResponse, UsersReadUserData, UsersReadUserResponse, UsersUpdateUserData, UsersUpdateUserResponse, UsersDeleteUserData, UsersDeleteUserResponse } from './types.gen';

export class AlertsService {
    /**
     * Alert Webhook
     * Receive Prometheus alert webhooks.
     *
     * Args:
     * webhook: The alert webhook payload
     * background_tasks: FastAPI background tasks
     *
     * Returns:
     * Acknowledgment response
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static alertWebhook(data: AlertsAlertWebhookData): CancelablePromise<AlertsAlertWebhookResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/alerts/webhook',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Critical Alert Webhook
     * Receive critical alert webhooks requiring immediate attention.
     *
     * Args:
     * webhook: The critical alert webhook payload
     * background_tasks: FastAPI background tasks
     *
     * Returns:
     * Acknowledgment response
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static criticalAlertWebhook(data: AlertsCriticalAlertWebhookData): CancelablePromise<AlertsCriticalAlertWebhookResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/alerts/critical',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Alert Status
     * Get alert system status and configuration.
     *
     * Returns:
     * Alert system status information
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getAlertStatus(): CancelablePromise<AlertsGetAlertStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/alerts/status'
        });
    }
    
}

export class CommandsService {
    /**
     * Retrieve a list of commands
     * Retrieve a list of paginated commands.
     *
     * - Requires superuser permissions.
     * - Supports pagination via `skip` and `limit` query parameters.
     * @param data The data for the request.
     * @param data.skip Number of records to skip for pagination
     * @param data.limit Maximum number of records to return
     * @returns CommandRead Successful Response
     * @throws ApiError
     */
    public static readCommands(data: CommandsReadCommandsData = {}): CancelablePromise<CommandsReadCommandsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/commands/',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                403: 'Not enough permissions to access this resource',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Retrieve a command by ID
     * Retrieve a specific command by its unique ID.
     *
     * - Requires superuser permissions.
     * - Returns a 404 error if the command does not exist.
     * @param data The data for the request.
     * @param data.id The unique ID of the command to retrieve
     * @returns CommandRead Successful Response
     * @throws ApiError
     */
    public static readCommand(data: CommandsReadCommandData): CancelablePromise<CommandsReadCommandResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/commands/{id}',
            path: {
                id: data.id
            },
            errors: {
                403: 'Not enough permissions to access this resource',
                404: 'Command not found',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete a command
     * Delete a command by its ID.
     *
     * - Requires superuser permissions.
     * - Returns a confirmation message on successful deletion.
     * - Returns a 404 error if the command does not exist.
     * @param data The data for the request.
     * @param data.id The ID of the command to delete
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteCommand(data: CommandsDeleteCommandData): CancelablePromise<CommandsDeleteCommandResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/commands/{id}',
            path: {
                id: data.id
            },
            errors: {
                403: 'Not enough permissions to delete the command',
                404: 'Command not found',
                422: 'Validation Error'
            }
        });
    }
    
}

export class DefaultService {
    /**
     * Get Metrics
     * Expose Prometheus metrics.
     *
     * Returns:
     * Prometheus metrics in text format
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getMetrics(): CancelablePromise<GetMetricsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/metrics'
        });
    }
    
    /**
     * Health Check
     * Health check endpoint for monitoring.
     *
     * Returns:
     * Health status information
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static healthCheck(): CancelablePromise<HealthCheckResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/health'
        });
    }
    
    /**
     * Get Circuit Breakers
     * Get circuit breaker health status.
     *
     * Returns:
     * Circuit breaker status for all registered breakers
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getCircuitBreakers(): CancelablePromise<GetCircuitBreakersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/circuit-breakers'
        });
    }
    
    /**
     * Reset Circuit Breaker
     * Reset a circuit breaker to CLOSED state.
     *
     * Args:
     * breaker_name: Name of the circuit breaker to reset
     *
     * Returns:
     * Success status
     * @param data The data for the request.
     * @param data.breakerName
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static resetCircuitBreaker(data: ResetCircuitBreakerData): CancelablePromise<ResetCircuitBreakerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/circuit-breakers/{breaker_name}/reset',
            path: {
                breaker_name: data.breakerName
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class DemoService {
    /**
     * Banner Status
     * Banner payload for the dashboard top banner.
     *
     * Returns ``{enabled: false}`` on non-demo clusters (NOT 404) so
     * the dashboard's first request to know whether to bypass /login
     * is a single round trip on every cluster.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static bannerStatus(): CancelablePromise<DemoBannerStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/demo/banner'
        });
    }
    
    /**
     * Create Visitor Session
     * Mint a JWT for an ephemeral demo visitor.
     *
     * 404 when demo mode is off — don't leak existence on prod clusters.
     * 503 when visitor_cap reached.
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static createVisitorSession(): CancelablePromise<DemoCreateVisitorSessionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/demo/visitor-session'
        });
    }
    
    /**
     * Self Provision Reader
     * Anonymous TapDPP onboarding — demo mode only.
     *
     * No PAT, no password, no human action required: the freeware
     * client posts an empty body (or an optional ``{device_id, name}``)
     * and receives a reader UUID + MQTT broker host/port + a username/
     * password/topic_id scoped to that reader.
     *
     * 404 when demo mode is off — the endpoint should be invisible on
     * production clusters; the freeware client falls back to its
     * "demo cluster unavailable" UI.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static selfProvisionReader(data: DemoSelfProvisionReaderData = {}): CancelablePromise<DemoSelfProvisionReaderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/demo/self-provision-reader',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class DppService {
    /**
     * Resolve a public Digital Product Passport
     * Return the public DPP payload for a tag identifier.
     *
     * The identifier is matched against ``tag.epcid`` then ``tag.url`` then
     * ``tag.url`` suffix — see :class:`DppResolverService`. Scoped to the
     * organisation that owns the request's ``Host`` (via
     * ``Organisation.dpp_host``), with a single-tenant fallback for clusters
     * that haven't backfilled the column.
     *
     * Returns 404 in three cases (indistinguishable on purpose, to avoid
     * enumeration):
     * - feature flag off
     * - no org claims this Host (and the cluster isn't single-tenant)
     * - no enabled+bound tag matches the identifier
     *
     * Successful responses set ``Cache-Control: public, max-age={
     * settings.DPP_CACHE_MAX_AGE_SECONDS}`` so caches and CDNs can serve
     * hot tags without hitting the API.
     * @param data The data for the request.
     * @param data.identifier
     * @returns DppPublic Successful Response
     * @throws ApiError
     */
    public static resolvePublicPassport(data: DppResolvePublicPassportData): CancelablePromise<DppResolvePublicPassportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dpp/{identifier}',
            path: {
                identifier: data.identifier
            },
            errors: {
                404: 'No matching public passport for this identifier',
                422: 'Validation Error',
                429: 'Rate limit exceeded'
            }
        });
    }
    
    /**
     * Bind a tag to a passport template from the public unbound page
     * Bind an unbound tag to a template without admin auth.
     *
     * Strictly gated by ``system_settings.is_demo_enabled()`` — outside
     * demo mode this endpoint returns 404 (same shape as a normal
     * not-found, so the SPA doesn't need conditional UI). The visitor's
     * selection persists onto ``Tag.dpp_template_id`` exactly like the
     * admin binding endpoint; no separate "DPP binding" table is touched.
     * @param data The data for the request.
     * @param data.identifier
     * @param data.requestBody
     * @returns DppPublic Successful Response
     * @throws ApiError
     */
    public static publicBindTagTemplate(data: DppPublicBindTagTemplateData): CancelablePromise<DppPublicBindTagTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dpp/{identifier}/bind-template',
            path: {
                identifier: data.identifier
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'Disabled outside demo mode or no match found',
                422: 'Validation Error',
                429: 'Rate limit exceeded'
            }
        });
    }
    
}

export class DppRecordsService {
    /**
     * Upsert Dpp Record By Sku
     * Upsert (insert-or-update) the DPP record for ``(org, gs1_sku)``.
     *
     * The pre-provisioning module's primary entry point. Callable before
     * any tag with this SKU has ever been scanned — the record waits in
     * the DB and is picked up by the public resolver as soon as a tag
     * whose ``Tag.sku`` matches appears.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.gs1Sku
     * @param data.requestBody
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static upsertDppRecordBySku(data: DppRecordsUpsertDppRecordBySkuData): CancelablePromise<DppRecordsUpsertDppRecordBySkuResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/by-sku/{gs1_sku}',
            path: {
                organisation_id: data.organisationId,
                gs1_sku: data.gs1Sku
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Dpp Records
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns DppRecordsPublic Successful Response
     * @throws ApiError
     */
    public static listDppRecords(data: DppRecordsListDppRecordsData): CancelablePromise<DppRecordsListDppRecordsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static createDppRecord(data: DppRecordsCreateDppRecordData): CancelablePromise<DppRecordsCreateDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.recordId
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static readDppRecord(data: DppRecordsReadDppRecordData): CancelablePromise<DppRecordsReadDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/{record_id}',
            path: {
                organisation_id: data.organisationId,
                record_id: data.recordId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.recordId
     * @param data.requestBody
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static updateDppRecord(data: DppRecordsUpdateDppRecordData): CancelablePromise<DppRecordsUpdateDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/{record_id}',
            path: {
                organisation_id: data.organisationId,
                record_id: data.recordId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.recordId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteDppRecord(data: DppRecordsDeleteDppRecordData): CancelablePromise<DppRecordsDeleteDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/{record_id}',
            path: {
                organisation_id: data.organisationId,
                record_id: data.recordId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class ItemsService {
    /**
     * Read Items
     * Retrieve items.
     *
     * Superusers can see all items.
     * Regular users can see their own items.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns ItemsPublic Successful Response
     * @throws ApiError
     */
    public static readItems(data: ItemsReadItemsData = {}): CancelablePromise<ItemsReadItemsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/items/',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Item
     * Create new item.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ItemPublic Successful Response
     * @throws ApiError
     */
    public static createItem(data: ItemsCreateItemData): CancelablePromise<ItemsCreateItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/items/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Item
     * Get item by id.
     *
     * Users can read their own items.
     * Superusers can read any item.
     * @param data The data for the request.
     * @param data.id
     * @returns ItemPublic Successful Response
     * @throws ApiError
     */
    public static readItem(data: ItemsReadItemData): CancelablePromise<ItemsReadItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/items/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Item
     * Update an item.
     *
     * Users can update their own items.
     * Superusers can update any item.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns ItemPublic Successful Response
     * @throws ApiError
     */
    public static updateItem(data: ItemsUpdateItemData): CancelablePromise<ItemsUpdateItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/items/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Item
     * Delete an item.
     *
     * Users can delete their own items.
     * Superusers can delete any item.
     * @param data The data for the request.
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteItem(data: ItemsDeleteItemData): CancelablePromise<ItemsDeleteItemResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/items/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class LicensesService {
    /**
     * Request Trial
     * Idempotent per device. Mints a trial the first time a device asks,
     * returns the existing license on a repeat call, or a purchase URL once the
     * trial has lapsed. (``request`` is required by slowapi's limiter.)
     *
     * On an active trial we also provision a Demo-org reader + MQTT credentials
     * (idempotent per device; the password rotates each call) and attach them as
     * the flat ``mqtt`` / ``device`` blocks so the client gets license + broker
     * credentials in one round-trip. Best-effort: a provisioning failure never
     * fails the trial — the client just gets a license-only response.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TrialResponse Successful Response
     * @throws ApiError
     */
    public static requestTrial(data: LicensesRequestTrialData): CancelablePromise<LicensesRequestTrialResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/licenses/request-trial',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Validate License
     * Validate a license key against its bound device.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ValidateResponse Successful Response
     * @throws ApiError
     */
    public static validateLicense(data: LicensesValidateLicenseData): CancelablePromise<LicensesValidateLicenseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/licenses/validate-license',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Revoke License
     * Revoke a license (device-initiated, e.g. on uninstall).
     * @param data The data for the request.
     * @param data.requestBody
     * @returns RevokeResponse Successful Response
     * @throws ApiError
     */
    public static revokeLicense(data: LicensesRevokeLicenseData): CancelablePromise<LicensesRevokeLicenseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/licenses/revoke-license',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Sync License
     * Periodic heartbeat: records telemetry and reports current validity.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SyncResponse Successful Response
     * @throws ApiError
     */
    public static syncLicense(data: LicensesSyncLicenseData): CancelablePromise<LicensesSyncLicenseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/licenses/sync-license',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Request License
     * Full / paid license request (QDatDroid §3.2). Not auto-granted.
     *
     * Lodges a lead + pending request for manual fulfilment and returns the
     * request-lodged shape (``success=True``, ``message``, ``purchase_url``, no
     * ``license``) → the client marks it ``isRequestPending``. If the device
     * already holds an active license, the auto-issue shape is returned instead
     * (``success=True`` + ``license``). An admin approves the request in the
     * dashboard, which mints a device-bound license delivered out of band via the
     * license QR → ``validate-license``. (``request`` is required by slowapi.)
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TrialResponse Successful Response
     * @throws ApiError
     */
    public static requestLicense(data: LicensesRequestLicenseData): CancelablePromise<LicensesRequestLicenseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/licenses/request-license',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class LoginService {
    /**
     * Login Access Token
     * OAuth2 compatible token login, get an access token for future requests.
     *
     * Records an AuthEvent row on every attempt — success or failure —
     * so the admin "Login activity" surface can show who connected when
     * from which IP, and surface failed-attempt patterns.
     *
     * Rate-limit gate: if the calling IP has an active row in ``ip_ban``,
     * the request is refused with HTTP 429 + Retry-After before any
     * password verification work happens. Each LOGIN_FAILURE feeds the
     * auto-ban service which counts recent failures from the same IP
     * against a configurable rolling window and inserts a ban when the
     * threshold is crossed. Tunables live in ``/admin-ip-bans``.
     * @param data The data for the request.
     * @param data.formData
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static loginAccessToken(data: LoginLoginAccessTokenData): CancelablePromise<LoginLoginAccessTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/access-token',
            formData: data.formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Login 2Sv Verify
     * Second step of a 2SV login: exchange the MFA challenge token + a TOTP
     * (or recovery) code for a real session token.
     *
     * The IP-ban gate applies here too, and a wrong code records a
     * LOGIN_FAILURE + feeds the auto-ban counter, so the 2SV step can't be
     * brute-forced any more freely than the password step.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static login2SvVerify(data: LoginLogin2SvVerifyData): CancelablePromise<LoginLogin2SvVerifyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/2sv-verify',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Logout
     * End the current login session.
     *
     * The session is identified by the JWT ``jti`` claim. For tokens
     * issued before sessions existed (no jti), this is a no-op that
     * still returns 200.
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static logout(): CancelablePromise<LoginLogoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/logout'
        });
    }
    
    /**
     * Test Token
     * Test access token
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static testToken(): CancelablePromise<LoginTestTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/test-token'
        });
    }
    
    /**
     * Refresh Token
     * Refresh access token, keeping the same session.
     *
     * Re-uses the existing ``jti`` so the user's session lifetime is not
     * fragmented across refreshes.
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static refreshToken(): CancelablePromise<LoginRefreshTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/refresh-token'
        });
    }
    
}

export class ManufacturersService {
    /**
     * List Manufacturers
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns ManufacturersPublic Successful Response
     * @throws ApiError
     */
    public static listManufacturers(data: ManufacturersListManufacturersData): CancelablePromise<ManufacturersListManufacturersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns ManufacturerRead Successful Response
     * @throws ApiError
     */
    public static createManufacturer(data: ManufacturersCreateManufacturerData): CancelablePromise<ManufacturersCreateManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.manufacturerId
     * @returns ManufacturerRead Successful Response
     * @throws ApiError
     */
    public static readManufacturer(data: ManufacturersReadManufacturerData): CancelablePromise<ManufacturersReadManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/{manufacturer_id}',
            path: {
                organisation_id: data.organisationId,
                manufacturer_id: data.manufacturerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.manufacturerId
     * @param data.requestBody
     * @returns ManufacturerRead Successful Response
     * @throws ApiError
     */
    public static updateManufacturer(data: ManufacturersUpdateManufacturerData): CancelablePromise<ManufacturersUpdateManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/{manufacturer_id}',
            path: {
                organisation_id: data.organisationId,
                manufacturer_id: data.manufacturerId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.manufacturerId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteManufacturer(data: ManufacturersDeleteManufacturerData): CancelablePromise<ManufacturersDeleteManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/{manufacturer_id}',
            path: {
                organisation_id: data.organisationId,
                manufacturer_id: data.manufacturerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class OrganisationsService {
    /**
     * Retrieve a list of organisations
     * Retrieve a paginated list of organisations.
     *
     * - Requires superuser permissions.
     * - Supports pagination via `skip` and `limit` query parameters.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns OrganisationRead Successful Response
     * @throws ApiError
     */
    public static readOrganisations(data: OrganisationsReadOrganisationsData = {}): CancelablePromise<OrganisationsReadOrganisationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                403: 'Not enough permissions to access this resource',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create a new organisation
     * Create a new organisation record.
     *
     * - Requires superuser privileges.
     * - Returns the newly created organisation.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns OrganisationRead Organisation successfully created
     * @throws ApiError
     */
    public static createOrganisation(data: OrganisationsCreateOrganisationData): CancelablePromise<OrganisationsCreateOrganisationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organisations/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: 'Not enough permissions to create an organisation',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organisation
     * Get organisation by id.
     *
     * Superusers can access any organisation.
     * Regular users can only access organisations they belong to.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns OrganisationRead Successful Response
     * @throws ApiError
     */
    public static readOrganisation(data: OrganisationsReadOrganisationData): CancelablePromise<OrganisationsReadOrganisationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{organisation_id}',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Organisation
     * Update an organisation.
     *
     * Superusers can update any organisation.
     * Regular users need UPDATE permission on the specific organisation.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns OrganisationRead Successful Response
     * @throws ApiError
     */
    public static updateOrganisation(data: OrganisationsUpdateOrganisationData): CancelablePromise<OrganisationsUpdateOrganisationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{organisation_id}',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Organisation
     * Delete an organisation and every row scoped to it.
     *
     * All FKs pointing at organisation.id are NOT NULL on the child tables, so
     * SQLAlchemy's default relationship cascade (set FK to NULL when the parent
     * is deleted) violates the NOT NULL constraint and aborts the transaction.
     * We explicitly DELETE the dependent rows in dependency order, then DELETE
     * the organisation row itself via raw SQL to bypass the ORM cascade.
     *
     * Superusers can delete any organisation.
     * Regular users need DELETE permission on the specific organisation.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteOrganisation(data: OrganisationsDeleteOrganisationData): CancelablePromise<OrganisationsDeleteOrganisationResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organisations/{organisation_id}',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Upload Organisation Logo
     * Upload and resize a logo for an organisation. Superusers or users with UPDATE permission.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.formData
     * @returns OrganisationRead Successful Response
     * @throws ApiError
     */
    public static uploadOrganisationLogo(data: OrganisationsUploadOrganisationLogoData): CancelablePromise<OrganisationsUploadOrganisationLogoResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organisations/{organisation_id}/logo',
            path: {
                organisation_id: data.organisationId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Organisation Logo
     * Remove the logo for an organisation. Superusers or users with UPDATE permission.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns OrganisationRead Successful Response
     * @throws ApiError
     */
    public static deleteOrganisationLogo(data: OrganisationsDeleteOrganisationLogoData): CancelablePromise<OrganisationsDeleteOrganisationLogoResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organisations/{organisation_id}/logo',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Organization Permissions
     * Get permissions for an organization.
     * Queries both new permission tables and legacy table for backward compatibility.
     * Filter by resource_type and/or user_id if provided.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.resourceType
     * @param data.userId
     * @returns ResourcePermissionRead Successful Response
     * @throws ApiError
     */
    public static getOrganizationPermissions(data: OrganisationsGetOrganizationPermissionsData): CancelablePromise<OrganisationsGetOrganizationPermissionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{organisation_id}/permissions',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                resource_type: data.resourceType,
                user_id: data.userId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Permission
     * Create or update a permission for a user on a resource within an organization.
     * Uses the new split-table approach: ResourceTypePermission for general permissions,
     * ResourceSpecificPermission for specific resource permissions.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.userId User ID to grant permission to
     * @param data.requestBody
     * @returns ResourcePermissionRead Successful Response
     * @throws ApiError
     */
    public static createPermission(data: OrganisationsCreatePermissionData): CancelablePromise<OrganisationsCreatePermissionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organisations/{organisation_id}/permissions',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                user_id: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Permission
     * Delete a permission for a user on a resource within an organization.
     * Uses the new split-table approach.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.userId
     * @param data.resourceType
     * @param data.resourceId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deletePermission(data: OrganisationsDeletePermissionData): CancelablePromise<OrganisationsDeletePermissionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organisations/{organisation_id}/permissions',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                user_id: data.userId,
                resource_type: data.resourceType,
                resource_id: data.resourceId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Setup User Permissions
     * Set up default permissions for a user in an organization based on their role.
     *
     * Available roles:
     * - admin: Full permissions on all resources including user and organization management
     * - operator: Read/write permissions on data resources, no admin permissions
     * - readonly: Read-only permissions on data resources
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns ResourcePermissionRead Successful Response
     * @throws ApiError
     */
    public static setupUserPermissions(data: OrganisationsSetupUserPermissionsData): CancelablePromise<OrganisationsSetupUserPermissionsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organisations/{organisation_id}/setup-user-permissions',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class OrganizationsService {
    /**
     * List users in an organisation
     * Return all users that belong to the given organisation via the OrganisationUsers M2M link. Requires READ on USER.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns UsersPublic Successful Response
     * @throws ApiError
     */
    public static usersReadOrganizationUsers(data: UsersReadOrganizationUsersData): CancelablePromise<UsersReadOrganizationUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/users/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Readers
     * Get all readers for a specific organization.
     *
     * Requires READ permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static readersReadOrganizationReaders(data: ReadersReadOrganizationReadersData): CancelablePromise<ReadersReadOrganizationReadersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Organization Reader
     * Create a new reader in the specified organization.
     *
     * Requires CREATE permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static readersCreateOrganizationReader(data: ReadersCreateOrganizationReaderData): CancelablePromise<ReadersCreateOrganizationReaderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Readers Paginated
     * Get paginated readers with optional filters and sorting.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @param data.search Search by name
     * @param data.model Filter by device model
     * @param data.role Filter by role
     * @param data.state Filter by state
     * @param data.sortBy Sort by column
     * @param data.sortOrder Sort order: asc or desc
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersReadOrganizationReadersPaginated(data: ReadersReadOrganizationReadersPaginatedData): CancelablePromise<ReadersReadOrganizationReadersPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/paginated',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search,
                model: data.model,
                role: data.role,
                state: data.state,
                sort_by: data.sortBy,
                sort_order: data.sortOrder
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Reader
     * Get a specific reader in an organization.
     *
     * Requires READ permission on readers.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static readersReadOrganizationReader(data: ReadersReadOrganizationReaderData): CancelablePromise<ReadersReadOrganizationReaderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Perform inventory scan on organization reader
     * Trigger an inventory scan on a reader within the organization.
     *
     * - Requires UPDATE permission on the reader
     * - Returns inventory scan results including detected tags
     * - Supports filtering by tag state and other parameters
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.details Include detailed information about each tag
     * @param data.fields Specific fields to include (only used with details)
     * @param data.state Filter tags by state (e.g., ARMED, LOGGING)
     * @param data.parser Specify the parser to use (opus or magnus)
     * @param data.outputFormat Output format (json, csv, or table)
     * @param data.transmitPower Transmission power (0-30 dBm)
     * @param data.timeout Timeout in seconds
     * @returns unknown Inventory scan completed successfully
     * @throws ApiError
     */
    public static readersOrganizationReaderInventory(data: ReadersOrganizationReaderInventoryData): CancelablePromise<ReadersOrganizationReaderInventoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/inventory',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                details: data.details,
                fields: data.fields,
                state: data.state,
                parser: data.parser,
                output_format: data.outputFormat,
                transmit_power: data.transmitPower,
                timeout: data.timeout
            },
            errors: {
                403: 'Not enough permissions to perform inventory',
                404: 'Reader not found in this organization',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Resume reader after native stop
     * Send a native FX9600 start command to un-stop the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderStart(data: ReadersOrganizationReaderStartData): CancelablePromise<ReadersOrganizationReaderStartResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/start',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Stop inventory scan on organization reader
     * Stop an ongoing RFID inventory scan on a reader within the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @returns unknown Stop command sent successfully
     * @throws ApiError
     */
    public static readersOrganizationReaderStop(data: ReadersOrganizationReaderStopData): CancelablePromise<ReadersOrganizationReaderStopResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/stop',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            errors: {
                403: 'Not enough permissions',
                404: 'Reader not found in this organization',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader operational status
     * Get operational statistics (tag read counts, uptime, etc.) from the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderGetStatus(data: ReadersOrganizationReaderGetStatusData): CancelablePromise<ReadersOrganizationReaderGetStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/status',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader firmware version
     * Get firmware and software version information from the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderGetVersion(data: ReadersOrganizationReaderGetVersionData): CancelablePromise<ReadersOrganizationReaderGetVersionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/version',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader configuration
     * Get full reader configuration including antenna, power, and mode settings.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderGetConfig(data: ReadersOrganizationReaderGetConfigData): CancelablePromise<ReadersOrganizationReaderGetConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/config',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Qdat application configuration
     * Get Qdat config (scan_duration, delay_between_scan, fixed_scan_count, etc.).
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderGetQdatConfig(data: ReadersOrganizationReaderGetQdatConfigData): CancelablePromise<ReadersOrganizationReaderGetQdatConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/qdat-config',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Qdat application configuration
     * Update Qdat application config parameters (scan_duration, delay_between_scan, etc.).
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.requestBody
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderSetQdatConfig(data: ReadersOrganizationReaderSetQdatConfigData): CancelablePromise<ReadersOrganizationReaderSetQdatConfigResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/qdat-config',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get recent commands for a reader
     * Return recent commands sent to this reader, newest first.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.limit
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderGetCommands(data: ReadersOrganizationReaderGetCommandsData): CancelablePromise<ReadersOrganizationReaderGetCommandsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/commands',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader operating mode
     * Get the current RFID operating mode (INVENTORY, etc.) from the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderGetMode(data: ReadersOrganizationReaderGetModeData): CancelablePromise<ReadersOrganizationReaderGetModeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/mode',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reboot the reader
     * Send a reboot command to the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readersOrganizationReaderReboot(data: ReadersOrganizationReaderRebootData): CancelablePromise<ReadersOrganizationReaderRebootResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/reboot',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Tags
     * Get all tags for a specific organization.
     *
     * Requires READ permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationTags(data: TagsReadOrganizationTagsData): CancelablePromise<TagsReadOrganizationTagsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Organization Tag
     * Upsert a tag in the specified organization, keyed on
     * ``(organisation_id, epcid)``.
     *
     * Behaves as an enrichment-aware create rather than a strict insert
     * so QDatDroid re-scans don't hit a UNIQUE constraint violation:
     *
     * * **201 Created**  — no prior row; new tag inserted.
     * * **200 OK**       — existing row was enriched (TID, URL,
     * chip_type, etc. backfilled from blank).
     * * **409 Conflict** — existing row is already complete; the request
     * carried nothing new. The response body is still the existing
     * ``TagRead`` so the caller can flush its stale-cache entry for
     * that EPC.
     *
     * Requires CREATE permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static tagsCreateOrganizationTag(data: TagsCreateOrganizationTagData): CancelablePromise<TagsCreateOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Organization Tag Trash
     * List soft-deleted tags (trash) for an organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsListOrganizationTagTrash(data: TagsListOrganizationTagTrashData): CancelablePromise<TagsListOrganizationTagTrashResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/trash',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Tags Paginated
     * Get paginated tags for a specific organization with optional filters.
     *
     * Returns data + total count for pagination.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @param data.search Search by name or EPC
     * @param data.tagType Filter by tag type
     * @param data.state Filter by tag state
     * @param data.readerId Filter by reader (last seen by)
     * @param data.parentId Filter by parent tag (children of)
     * @param data.tagTemplateId Filter by the TagTemplate the tag was created from
     * @param data.dppTemplateId Filter by DPP binding: a PassportTemplate UUID limits to tags bound to that template; the literal 'unbound' returns tags with dpp_template_id IS NULL; omit to skip the filter.
     * @param data.sortBy Sort by column
     * @param data.sortOrder Sort order: asc or desc
     * @returns TagsPublic Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationTagsPaginated(data: TagsReadOrganizationTagsPaginatedData): CancelablePromise<TagsReadOrganizationTagsPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/paginated',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search,
                tag_type: data.tagType,
                state: data.state,
                reader_id: data.readerId,
                parent_id: data.parentId,
                tag_template_id: data.tagTemplateId,
                dpp_template_id: data.dppTemplateId,
                sort_by: data.sortBy,
                sort_order: data.sortOrder
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Tags Map
     * Lightweight tag feed for the map view.
     *
     * Returns only located tags (last_lat/last_lon set) and only the fields the
     * map needs (id, name, epcid, state, position, last seen). This trims the
     * payload dramatically versus the full paginated endpoint, so orgs with 100K+
     * tags load fast. One request — no client-side paging loop.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.limit
     * @returns TagMapPoints Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationTagsMap(data: TagsReadOrganizationTagsMapData): CancelablePromise<TagsReadOrganizationTagsMapResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/map',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List distinct Tag.category values in this organisation
     * Return the distinct non-null ``Tag.category`` values in use, with the
     * count of tags using each. Drives the category pulldown on the tag
     * form so operators pick from values already in use instead of
     * free-typing duplicates.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsListDistinctTagCategories(data: TagsListDistinctTagCategoriesData): CancelablePromise<TagsListDistinctTagCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/distinct-categories',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List distinct Tag.sku values in this organisation
     * Return the distinct non-null ``Tag.sku`` values in use, with usage
     * counts. Drives the SKU pulldown on the tag form.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsListDistinctTagSkus(data: TagsListDistinctTagSkusData): CancelablePromise<TagsListDistinctTagSkusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/distinct-skus',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get recent tag readings for all tags in organization
     * Get recent tag inventory events across all tags in the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.minutes Look-back window in minutes
     * @param data.limit Max number of results
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsGetOrganizationRecentActivity(data: TagsGetOrganizationRecentActivityData): CancelablePromise<TagsGetOrganizationRecentActivityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/recent-activity',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                minutes: data.minutes,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get paginated tag events for organization
     * Get paginated events with total count for an organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @param data.minutes Look-back window in minutes
     * @param data.search Search by tag name or EPC
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsGetOrganizationEventsPaginated(data: TagsGetOrganizationEventsPaginatedData): CancelablePromise<TagsGetOrganizationEventsPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/events/paginated',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                minutes: data.minutes,
                search: data.search
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get events for a specific tag in an organization
     * Get events for a specific tag, scoped to organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.skip
     * @param data.limit
     * @returns TagEventRead Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationTagEvents(data: TagsReadOrganizationTagEventsData): CancelablePromise<TagsReadOrganizationTagEventsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/events',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get barcode scans for a specific tag in an organization
     * Get barcode scans for a specific tag (newest first), scoped to org.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.skip
     * @param data.limit
     * @returns TagBarcodeScanRead Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationTagBarcodeScans(data: TagsReadOrganizationTagBarcodeScansData): CancelablePromise<TagsReadOrganizationTagBarcodeScansResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/barcode-scans',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get multimodal scan bundles anchored to a tag
     * Get multimodal scan bundles anchored to a tag (newest first).
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.skip
     * @param data.limit
     * @returns MultimodalScanRead Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationTagMultimodalScans(data: TagsReadOrganizationTagMultimodalScansData): CancelablePromise<TagsReadOrganizationTagMultimodalScansResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/multimodal-scans',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get a multimodal scan bundle by its stable scan_id
     * Get a single multimodal bundle by scan_id, scoped to the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.scanId
     * @returns MultimodalScanRead Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationMultimodalScan(data: TagsReadOrganizationMultimodalScanData): CancelablePromise<TagsReadOrganizationMultimodalScanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/multimodal-scans/{scan_id}',
            path: {
                organisation_id: data.organisationId,
                scan_id: data.scanId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Tag
     * Get a specific tag in an organization.
     *
     * Requires READ permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static tagsReadOrganizationTag(data: TagsReadOrganizationTagData): CancelablePromise<TagsReadOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Organization Tag
     * Update a specific tag in an organization.
     *
     * Requires UPDATE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.requestBody
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static tagsUpdateOrganizationTag(data: TagsUpdateOrganizationTagData): CancelablePromise<TagsUpdateOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Organization Tag
     * Soft-delete a tag (moves it to trash, preserving all historical data).
     *
     * Requires DELETE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagsDeleteOrganizationTag(data: TagsDeleteOrganizationTagData): CancelablePromise<TagsDeleteOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Upload an image for a tag
     * Upload an image for a tag. Appends to images list.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.formData
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsUploadTagImage(data: TagsUploadTagImageData): CancelablePromise<TagsUploadTagImageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/upload-image',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete a tag image by index
     * Delete an image from a tag's images list by index.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.imageIndex
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsDeleteTagImage(data: TagsDeleteTagImageData): CancelablePromise<TagsDeleteTagImageResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/images/{image_index}',
            path: {
                organisation_id: data.organisationId,
                id: data.id,
                image_index: data.imageIndex
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Bulk Delete Organization Tags
     * Soft-delete multiple tags in a single request (moves them to trash).
     *
     * Requires DELETE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagsBulkDeleteOrganizationTags(data: TagsBulkDeleteOrganizationTagsData): CancelablePromise<TagsBulkDeleteOrganizationTagsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/bulk-delete',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Restore Organization Tag
     * Restore a soft-deleted tag from trash.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagsRestoreOrganizationTag(data: TagsRestoreOrganizationTagData): CancelablePromise<TagsRestoreOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/restore',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Bulk Restore Organization Tags
     * Restore multiple soft-deleted tags from trash in a single request.
     *
     * Requires DELETE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagsBulkRestoreOrganizationTags(data: TagsBulkRestoreOrganizationTagsData): CancelablePromise<TagsBulkRestoreOrganizationTagsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/bulk-restore',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Permanently Delete Organization Tag
     * Permanently delete a tag and all its data, bypassing the trash.
     *
     * The trash precondition was removed in 2.0.0 — operators can now
     * delete directly from the edit page with a confirmation. Soft-delete
     * via the trash flow is still available for reversible removals; this
     * endpoint is the one-shot "purge everything" path.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagsPermanentlyDeleteOrganizationTag(data: TagsPermanentlyDeleteOrganizationTagData): CancelablePromise<TagsPermanentlyDeleteOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/permanent',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get timestamp of the first reading for a tag
     * Return the timestamp of the earliest recorded reading for a tag.
     * Used by the dashboard to set the Grafana time range.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static tagsGetOrganizationTagFirstReading(data: TagsGetOrganizationTagFirstReadingData): CancelablePromise<TagsGetOrganizationTagFirstReadingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/first-reading',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Templates
     * Get all tag templates for a specific organization.
     *
     * Requires READ permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static tagTemplatesReadOrganizationTemplates(data: TagTemplatesReadOrganizationTemplatesData): CancelablePromise<TagTemplatesReadOrganizationTemplatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Organization Template
     * Create a new tag template in the specified organization.
     *
     * Requires CREATE permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static tagTemplatesCreateOrganizationTemplate(data: TagTemplatesCreateOrganizationTemplateData): CancelablePromise<TagTemplatesCreateOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List chip_type values selectable for templates (catalog + observed)
     * Return the union of:
     *
     * 1. The bundled QDatDroid identifier catalog (``tag_type`` +
     * ``chip_manufacturer`` + ``cin_brand`` + ``nfc_ic_manufacturer`` —
     * see ``app/data/qdat-io-tag-types.json``); and
     * 2. The distinct ``chip_type`` values currently observed on this org's
     * tag table (catches any operator-typed or vendor-emitted value not
     * yet in the catalog).
     *
     * The result populates the chip_type combobox in the template editor so
     * an operator can pre-create a template for any identifier QDatDroid
     * might emit — even before a tag of that type has been scanned.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static tagTemplatesListObservedChipTypes(data: TagTemplatesListObservedChipTypesData): CancelablePromise<TagTemplatesListObservedChipTypesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/observed-chip-types',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Full QDatDroid identifier catalog grouped by category
     * Return the bundled catalog (``app/data/qdat-io-tag-types.json``)
     * grouped by identifier category, along with the binding-field priority
     * order used by the ingester. Frontend uses this to render a richer
     * typeahead grouped by category (tag_type → chip_manufacturer →
     * cin_brand → nfc_ic_manufacturer).
     * @param data The data for the request.
     * @param data.organisationId
     * @returns TagCatalogResponse Successful Response
     * @throws ApiError
     */
    public static tagTemplatesGetTagCatalog(data: TagTemplatesGetTagCatalogData): CancelablePromise<TagTemplatesGetTagCatalogResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/catalog',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Template
     * Get a specific tag template in an organization.
     *
     * Requires READ permission on tag templates.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static tagTemplatesReadOrganizationTemplate(data: TagTemplatesReadOrganizationTemplateData): CancelablePromise<TagTemplatesReadOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Organization Template
     * Update a specific tag template in an organization.
     *
     * Requires UPDATE permission on tag templates.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.requestBody
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static tagTemplatesUpdateOrganizationTemplate(data: TagTemplatesUpdateOrganizationTemplateData): CancelablePromise<TagTemplatesUpdateOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Organization Template
     * Delete a tag template, cascading any bound tags onto the org's Default.
     *
     * The Default template (``is_default=True``) is protected — attempting
     * to delete it returns 400. For every other template, this handler:
     *
     * 1. Looks up the org's Default template.
     * 2. Re-points all ``tag.tag_template_id`` rows that referenced the
     * deleted template to the Default (also updates ``tag.tag_type`` so
     * tag and template stay consistent).
     * 3. Deletes the template.
     *
     * Requires DELETE permission on tag templates.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagTemplatesDeleteOrganizationTemplate(data: TagTemplatesDeleteOrganizationTemplateData): CancelablePromise<TagTemplatesDeleteOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Cluster-derived DPP settings
     * Return MQTT host + derived DPP host + public-resolver flags.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static passportTemplatesGetDppClusterInfoInline(data: PassportTemplatesGetDppClusterInfoInlineData): CancelablePromise<PassportTemplatesGetDppClusterInfoInlineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/_cluster-info',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Passport Templates
     * List passport templates for an organisation.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns PassportTemplatesPublic Successful Response
     * @throws ApiError
     */
    public static passportTemplatesListPassportTemplates(data: PassportTemplatesListPassportTemplatesData): CancelablePromise<PassportTemplatesListPassportTemplatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Passport Template
     * Create a passport template scoped to the path's organisation.
     *
     * The body's ``organisation_id`` is overridden by the path parameter so
     * a caller can't smuggle a template into someone else's org.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns PassportTemplateRead Successful Response
     * @throws ApiError
     */
    public static passportTemplatesCreatePassportTemplate(data: PassportTemplatesCreatePassportTemplateData): CancelablePromise<PassportTemplatesCreatePassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Passport Template
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.templateId
     * @returns PassportTemplateRead Successful Response
     * @throws ApiError
     */
    public static passportTemplatesReadPassportTemplate(data: PassportTemplatesReadPassportTemplateData): CancelablePromise<PassportTemplatesReadPassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/{template_id}',
            path: {
                organisation_id: data.organisationId,
                template_id: data.templateId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Passport Template
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.templateId
     * @param data.requestBody
     * @returns PassportTemplateRead Successful Response
     * @throws ApiError
     */
    public static passportTemplatesUpdatePassportTemplate(data: PassportTemplatesUpdatePassportTemplateData): CancelablePromise<PassportTemplatesUpdatePassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/{template_id}',
            path: {
                organisation_id: data.organisationId,
                template_id: data.templateId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Passport Template
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.templateId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static passportTemplatesDeletePassportTemplate(data: PassportTemplatesDeletePassportTemplateData): CancelablePromise<PassportTemplatesDeletePassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/{template_id}',
            path: {
                organisation_id: data.organisationId,
                template_id: data.templateId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Manufacturers
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns ManufacturersPublic Successful Response
     * @throws ApiError
     */
    public static manufacturersListManufacturers(data: ManufacturersListManufacturersData): CancelablePromise<ManufacturersListManufacturersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns ManufacturerRead Successful Response
     * @throws ApiError
     */
    public static manufacturersCreateManufacturer(data: ManufacturersCreateManufacturerData): CancelablePromise<ManufacturersCreateManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.manufacturerId
     * @returns ManufacturerRead Successful Response
     * @throws ApiError
     */
    public static manufacturersReadManufacturer(data: ManufacturersReadManufacturerData): CancelablePromise<ManufacturersReadManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/{manufacturer_id}',
            path: {
                organisation_id: data.organisationId,
                manufacturer_id: data.manufacturerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.manufacturerId
     * @param data.requestBody
     * @returns ManufacturerRead Successful Response
     * @throws ApiError
     */
    public static manufacturersUpdateManufacturer(data: ManufacturersUpdateManufacturerData): CancelablePromise<ManufacturersUpdateManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/{manufacturer_id}',
            path: {
                organisation_id: data.organisationId,
                manufacturer_id: data.manufacturerId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Manufacturer
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.manufacturerId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static manufacturersDeleteManufacturer(data: ManufacturersDeleteManufacturerData): CancelablePromise<ManufacturersDeleteManufacturerResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/manufacturers/{manufacturer_id}',
            path: {
                organisation_id: data.organisationId,
                manufacturer_id: data.manufacturerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Representatives
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns RepresentativesPublic Successful Response
     * @throws ApiError
     */
    public static representativesListRepresentatives(data: RepresentativesListRepresentativesData): CancelablePromise<RepresentativesListRepresentativesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/representatives/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns RepresentativeRead Successful Response
     * @throws ApiError
     */
    public static representativesCreateRepresentative(data: RepresentativesCreateRepresentativeData): CancelablePromise<RepresentativesCreateRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/representatives/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.representativeId
     * @returns RepresentativeRead Successful Response
     * @throws ApiError
     */
    public static representativesReadRepresentative(data: RepresentativesReadRepresentativeData): CancelablePromise<RepresentativesReadRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/representatives/{representative_id}',
            path: {
                organisation_id: data.organisationId,
                representative_id: data.representativeId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.representativeId
     * @param data.requestBody
     * @returns RepresentativeRead Successful Response
     * @throws ApiError
     */
    public static representativesUpdateRepresentative(data: RepresentativesUpdateRepresentativeData): CancelablePromise<RepresentativesUpdateRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/representatives/{representative_id}',
            path: {
                organisation_id: data.organisationId,
                representative_id: data.representativeId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.representativeId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static representativesDeleteRepresentative(data: RepresentativesDeleteRepresentativeData): CancelablePromise<RepresentativesDeleteRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/representatives/{representative_id}',
            path: {
                organisation_id: data.organisationId,
                representative_id: data.representativeId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Upsert Dpp Record By Sku
     * Upsert (insert-or-update) the DPP record for ``(org, gs1_sku)``.
     *
     * The pre-provisioning module's primary entry point. Callable before
     * any tag with this SKU has ever been scanned — the record waits in
     * the DB and is picked up by the public resolver as soon as a tag
     * whose ``Tag.sku`` matches appears.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.gs1Sku
     * @param data.requestBody
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static dppRecordsUpsertDppRecordBySku(data: DppRecordsUpsertDppRecordBySkuData): CancelablePromise<DppRecordsUpsertDppRecordBySkuResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/by-sku/{gs1_sku}',
            path: {
                organisation_id: data.organisationId,
                gs1_sku: data.gs1Sku
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Dpp Records
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns DppRecordsPublic Successful Response
     * @throws ApiError
     */
    public static dppRecordsListDppRecords(data: DppRecordsListDppRecordsData): CancelablePromise<DppRecordsListDppRecordsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static dppRecordsCreateDppRecord(data: DppRecordsCreateDppRecordData): CancelablePromise<DppRecordsCreateDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.recordId
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static dppRecordsReadDppRecord(data: DppRecordsReadDppRecordData): CancelablePromise<DppRecordsReadDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/{record_id}',
            path: {
                organisation_id: data.organisationId,
                record_id: data.recordId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.recordId
     * @param data.requestBody
     * @returns DppRecordRead Successful Response
     * @throws ApiError
     */
    public static dppRecordsUpdateDppRecord(data: DppRecordsUpdateDppRecordData): CancelablePromise<DppRecordsUpdateDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/{record_id}',
            path: {
                organisation_id: data.organisationId,
                record_id: data.recordId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Dpp Record
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.recordId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static dppRecordsDeleteDppRecord(data: DppRecordsDeleteDppRecordData): CancelablePromise<DppRecordsDeleteDppRecordResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/dpp-records/{record_id}',
            path: {
                organisation_id: data.organisationId,
                record_id: data.recordId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Tag Categories
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagCategoriesPublic Successful Response
     * @throws ApiError
     */
    public static tagCategoriesListTagCategories(data: TagCategoriesListTagCategoriesData): CancelablePromise<TagCategoriesListTagCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagCategoryRead Successful Response
     * @throws ApiError
     */
    public static tagCategoriesCreateTagCategory(data: TagCategoriesCreateTagCategoryData): CancelablePromise<TagCategoriesCreateTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.categoryId
     * @returns TagCategoryRead Successful Response
     * @throws ApiError
     */
    public static tagCategoriesReadTagCategory(data: TagCategoriesReadTagCategoryData): CancelablePromise<TagCategoriesReadTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/{category_id}',
            path: {
                organisation_id: data.organisationId,
                category_id: data.categoryId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.categoryId
     * @param data.requestBody
     * @returns TagCategoryRead Successful Response
     * @throws ApiError
     */
    public static tagCategoriesUpdateTagCategory(data: TagCategoriesUpdateTagCategoryData): CancelablePromise<TagCategoriesUpdateTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/{category_id}',
            path: {
                organisation_id: data.organisationId,
                category_id: data.categoryId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.categoryId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagCategoriesDeleteTagCategory(data: TagCategoriesDeleteTagCategoryData): CancelablePromise<TagCategoriesDeleteTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/{category_id}',
            path: {
                organisation_id: data.organisationId,
                category_id: data.categoryId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Tag Skus
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagSkuCatalogPublic Successful Response
     * @throws ApiError
     */
    public static tagSkUsListTagSkus(data: TagSkUsListTagSkusData): CancelablePromise<TagSkUsListTagSkusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagSkuCatalogRead Successful Response
     * @throws ApiError
     */
    public static tagSkUsCreateTagSku(data: TagSkUsCreateTagSkuData): CancelablePromise<TagSkUsCreateTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skuId
     * @returns TagSkuCatalogRead Successful Response
     * @throws ApiError
     */
    public static tagSkUsReadTagSku(data: TagSkUsReadTagSkuData): CancelablePromise<TagSkUsReadTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/{sku_id}',
            path: {
                organisation_id: data.organisationId,
                sku_id: data.skuId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skuId
     * @param data.requestBody
     * @returns TagSkuCatalogRead Successful Response
     * @throws ApiError
     */
    public static tagSkUsUpdateTagSku(data: TagSkUsUpdateTagSkuData): CancelablePromise<TagSkUsUpdateTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/{sku_id}',
            path: {
                organisation_id: data.organisationId,
                sku_id: data.skuId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skuId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static tagSkUsDeleteTagSku(data: TagSkUsDeleteTagSkuData): CancelablePromise<TagSkUsDeleteTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/{sku_id}',
            path: {
                organisation_id: data.organisationId,
                sku_id: data.skuId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class PassportTemplatesService {
    /**
     * Cluster-derived DPP settings
     * Return MQTT host + derived DPP host + public-resolver flags.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getDppClusterInfoInline(data: PassportTemplatesGetDppClusterInfoInlineData): CancelablePromise<PassportTemplatesGetDppClusterInfoInlineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/_cluster-info',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Passport Templates
     * List passport templates for an organisation.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns PassportTemplatesPublic Successful Response
     * @throws ApiError
     */
    public static listPassportTemplates(data: PassportTemplatesListPassportTemplatesData): CancelablePromise<PassportTemplatesListPassportTemplatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Passport Template
     * Create a passport template scoped to the path's organisation.
     *
     * The body's ``organisation_id`` is overridden by the path parameter so
     * a caller can't smuggle a template into someone else's org.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns PassportTemplateRead Successful Response
     * @throws ApiError
     */
    public static createPassportTemplate(data: PassportTemplatesCreatePassportTemplateData): CancelablePromise<PassportTemplatesCreatePassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Passport Template
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.templateId
     * @returns PassportTemplateRead Successful Response
     * @throws ApiError
     */
    public static readPassportTemplate(data: PassportTemplatesReadPassportTemplateData): CancelablePromise<PassportTemplatesReadPassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/{template_id}',
            path: {
                organisation_id: data.organisationId,
                template_id: data.templateId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Passport Template
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.templateId
     * @param data.requestBody
     * @returns PassportTemplateRead Successful Response
     * @throws ApiError
     */
    public static updatePassportTemplate(data: PassportTemplatesUpdatePassportTemplateData): CancelablePromise<PassportTemplatesUpdatePassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/{template_id}',
            path: {
                organisation_id: data.organisationId,
                template_id: data.templateId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Passport Template
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.templateId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deletePassportTemplate(data: PassportTemplatesDeletePassportTemplateData): CancelablePromise<PassportTemplatesDeletePassportTemplateResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/passport-templates/{template_id}',
            path: {
                organisation_id: data.organisationId,
                template_id: data.templateId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Set Tag Passport Binding
     * Set, clear, or lock a tag's public passport binding.
     *
     * Body shape: ``{template_id: UUID|null, locked: bool}``.
     *
     * - ``template_id=null`` clears the binding (tag has no public page).
     * - ``locked=true`` prevents the ingester auto-bind hook from
     * overwriting the binding on subsequent SCANs.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.tagId
     * @param data.requestBody
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static tagsSetTagPassportBinding(data: TagsSetTagPassportBindingData): CancelablePromise<TagsSetTagPassportBindingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/{tag_id}/passport-binding',
            path: {
                organisation_id: data.organisationId,
                tag_id: data.tagId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class ReadersService {
    /**
     * Retrieve a list of readers
     * Returns a paginated list of all readers in the system.
     *
     * - Requires superuser permissions.
     * - Supports pagination via `skip` and `limit` query parameters.
     * @param data The data for the request.
     * @param data.organizationId Filter by organization
     * @param data.skip
     * @param data.limit
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static readReaders(data: ReadersReadReadersData = {}): CancelablePromise<ReadersReadReadersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/readers/',
            query: {
                organization_id: data.organizationId,
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                403: 'Not enough permissions to access this resource',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create a new reader
     * Create a new reader record.
     *
     * - Requires superuser permissions.
     * - Returns the newly created reader object.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.organisationId Organization to create reader in
     * @param data.rebind If a reader already owns this MAC / device id, re-bind that existing reader to this provisioning (move it to the target organization and update its fields) instead of failing with 409. Used by the license provisioning wizard.
     * @returns ReaderRead Reader successfully created
     * @throws ApiError
     */
    public static createReader(data: ReadersCreateReaderData): CancelablePromise<ReadersCreateReaderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/readers/',
            query: {
                organisation_id: data.organisationId,
                rebind: data.rebind
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: 'Not enough permissions to create reader',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Readers Paginated
     * Get paginated readers across all organizations (superuser only).
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @param data.search
     * @param data.model
     * @param data.role
     * @param data.state
     * @param data.organisationId
     * @param data.sortBy
     * @param data.sortOrder
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readReadersPaginated(data: ReadersReadReadersPaginatedData = {}): CancelablePromise<ReadersReadReadersPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/readers/paginated',
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search,
                model: data.model,
                role: data.role,
                state: data.state,
                organisation_id: data.organisationId,
                sort_by: data.sortBy,
                sort_order: data.sortOrder
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Reader
     * Get reader by id.
     *
     * Superusers can access any reader.
     * Regular users can only access readers in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static readReader(data: ReadersReadReaderData): CancelablePromise<ReadersReadReaderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/readers/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Reader
     * Update a reader.
     *
     * Superusers can update any reader.
     * Regular users can only update readers in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static updateReader(data: ReadersUpdateReaderData): CancelablePromise<ReadersUpdateReaderResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/readers/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Reader
     * Delete a reader.
     *
     * Superusers can delete any reader.
     * Regular users can only delete readers in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteReader(data: ReadersDeleteReaderData): CancelablePromise<ReadersDeleteReaderResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/readers/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Perform inventory scan on reader
     * Trigger an inventory scan on the specified reader to detect RFID tags.
     *
     * - Requires superuser permissions
     * - Returns inventory scan results including detected tags
     * - Supports filtering by tag state and other parameters
     * @param data The data for the request.
     * @param data.id
     * @param data.details Include detailed information about each tag
     * @param data.fields Specific fields to include (only used with details)
     * @param data.state Filter tags by state (e.g., ARMED, LOGGING)
     * @param data.parser Specify the parser to use (opus or magnus)
     * @param data.outputFormat Output format (json, csv, or table)
     * @param data.transmitPower Transmission power (0-30 dBm)
     * @param data.timeout Timeout in seconds
     * @returns unknown Inventory scan completed successfully
     * @throws ApiError
     */
    public static readerInventory(data: ReadersReaderInventoryData): CancelablePromise<ReadersReaderInventoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/readers/{id}/inventory',
            path: {
                id: data.id
            },
            query: {
                details: data.details,
                fields: data.fields,
                state: data.state,
                parser: data.parser,
                output_format: data.outputFormat,
                transmit_power: data.transmitPower,
                timeout: data.timeout
            },
            errors: {
                403: 'Not enough permissions to perform inventory',
                404: 'Reader not found',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Generate MQTT credentials for a reader
     * Generate new MQTT credentials and topic UUID. The password is returned once.
     * @param data The data for the request.
     * @param data.id
     * @returns ReaderMQTTCredentialResponse Successful Response
     * @throws ApiError
     */
    public static generateMqttCredentials(data: ReadersGenerateMqttCredentialsData): CancelablePromise<ReadersGenerateMqttCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/readers/{id}/mqtt-credentials',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Revoke MQTT credentials for a reader
     * Revoke MQTT credentials and remove the dynsec entries.
     * @param data The data for the request.
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static revokeMqttCredentials(data: ReadersRevokeMqttCredentialsData): CancelablePromise<ReadersRevokeMqttCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/readers/{id}/mqtt-credentials',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Regenerate MQTT credentials for a reader
     * Revoke existing credentials and generate new ones (new UUID + password).
     * @param data The data for the request.
     * @param data.id
     * @returns ReaderMQTTCredentialResponse Successful Response
     * @throws ApiError
     */
    public static regenerateMqttCredentials(data: ReadersRegenerateMqttCredentialsData): CancelablePromise<ReadersRegenerateMqttCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/readers/{id}/mqtt-credentials/regenerate',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get MQTT credential status for a reader
     * Get credential status (without the password).
     * @param data The data for the request.
     * @param data.id
     * @returns ReaderMQTTCredentialStatus Successful Response
     * @throws ApiError
     */
    public static getMqttCredentialStatus(data: ReadersGetMqttCredentialStatusData): CancelablePromise<ReadersGetMqttCredentialStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/readers/{id}/mqtt-credentials/status',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Stop inventory scan on reader
     * Stop an ongoing RFID inventory scan on the specified reader.
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Stop command sent successfully
     * @throws ApiError
     */
    public static readerStop(data: ReadersReaderStopData): CancelablePromise<ReadersReaderStopResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/readers/{id}/stop',
            path: {
                id: data.id
            },
            errors: {
                403: 'Not enough permissions',
                404: 'Reader not found',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Readers
     * Get all readers for a specific organization.
     *
     * Requires READ permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationReaders(data: ReadersReadOrganizationReadersData): CancelablePromise<ReadersReadOrganizationReadersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Organization Reader
     * Create a new reader in the specified organization.
     *
     * Requires CREATE permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static createOrganizationReader(data: ReadersCreateOrganizationReaderData): CancelablePromise<ReadersCreateOrganizationReaderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Readers Paginated
     * Get paginated readers with optional filters and sorting.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @param data.search Search by name
     * @param data.model Filter by device model
     * @param data.role Filter by role
     * @param data.state Filter by state
     * @param data.sortBy Sort by column
     * @param data.sortOrder Sort order: asc or desc
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static readOrganizationReadersPaginated(data: ReadersReadOrganizationReadersPaginatedData): CancelablePromise<ReadersReadOrganizationReadersPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/paginated',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search,
                model: data.model,
                role: data.role,
                state: data.state,
                sort_by: data.sortBy,
                sort_order: data.sortOrder
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Reader
     * Get a specific reader in an organization.
     *
     * Requires READ permission on readers.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @returns ReaderRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationReader(data: ReadersReadOrganizationReaderData): CancelablePromise<ReadersReadOrganizationReaderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Perform inventory scan on organization reader
     * Trigger an inventory scan on a reader within the organization.
     *
     * - Requires UPDATE permission on the reader
     * - Returns inventory scan results including detected tags
     * - Supports filtering by tag state and other parameters
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.details Include detailed information about each tag
     * @param data.fields Specific fields to include (only used with details)
     * @param data.state Filter tags by state (e.g., ARMED, LOGGING)
     * @param data.parser Specify the parser to use (opus or magnus)
     * @param data.outputFormat Output format (json, csv, or table)
     * @param data.transmitPower Transmission power (0-30 dBm)
     * @param data.timeout Timeout in seconds
     * @returns unknown Inventory scan completed successfully
     * @throws ApiError
     */
    public static organizationReaderInventory(data: ReadersOrganizationReaderInventoryData): CancelablePromise<ReadersOrganizationReaderInventoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/inventory',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                details: data.details,
                fields: data.fields,
                state: data.state,
                parser: data.parser,
                output_format: data.outputFormat,
                transmit_power: data.transmitPower,
                timeout: data.timeout
            },
            errors: {
                403: 'Not enough permissions to perform inventory',
                404: 'Reader not found in this organization',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Resume reader after native stop
     * Send a native FX9600 start command to un-stop the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderStart(data: ReadersOrganizationReaderStartData): CancelablePromise<ReadersOrganizationReaderStartResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/start',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Stop inventory scan on organization reader
     * Stop an ongoing RFID inventory scan on a reader within the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @returns unknown Stop command sent successfully
     * @throws ApiError
     */
    public static organizationReaderStop(data: ReadersOrganizationReaderStopData): CancelablePromise<ReadersOrganizationReaderStopResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/stop',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            errors: {
                403: 'Not enough permissions',
                404: 'Reader not found in this organization',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader operational status
     * Get operational statistics (tag read counts, uptime, etc.) from the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderGetStatus(data: ReadersOrganizationReaderGetStatusData): CancelablePromise<ReadersOrganizationReaderGetStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/status',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader firmware version
     * Get firmware and software version information from the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderGetVersion(data: ReadersOrganizationReaderGetVersionData): CancelablePromise<ReadersOrganizationReaderGetVersionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/version',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader configuration
     * Get full reader configuration including antenna, power, and mode settings.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderGetConfig(data: ReadersOrganizationReaderGetConfigData): CancelablePromise<ReadersOrganizationReaderGetConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/config',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Qdat application configuration
     * Get Qdat config (scan_duration, delay_between_scan, fixed_scan_count, etc.).
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderGetQdatConfig(data: ReadersOrganizationReaderGetQdatConfigData): CancelablePromise<ReadersOrganizationReaderGetQdatConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/qdat-config',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Qdat application configuration
     * Update Qdat application config parameters (scan_duration, delay_between_scan, etc.).
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.requestBody
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderSetQdatConfig(data: ReadersOrganizationReaderSetQdatConfigData): CancelablePromise<ReadersOrganizationReaderSetQdatConfigResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/qdat-config',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get recent commands for a reader
     * Return recent commands sent to this reader, newest first.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.limit
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderGetCommands(data: ReadersOrganizationReaderGetCommandsData): CancelablePromise<ReadersOrganizationReaderGetCommandsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/commands',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get reader operating mode
     * Get the current RFID operating mode (INVENTORY, etc.) from the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderGetMode(data: ReadersOrganizationReaderGetModeData): CancelablePromise<ReadersOrganizationReaderGetModeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/mode',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reboot the reader
     * Send a reboot command to the reader.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.readerId
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static organizationReaderReboot(data: ReadersOrganizationReaderRebootData): CancelablePromise<ReadersOrganizationReaderRebootResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/readers/{reader_id}/reboot',
            path: {
                organisation_id: data.organisationId,
                reader_id: data.readerId
            },
            query: {
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class RepresentativesService {
    /**
     * List Representatives
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns RepresentativesPublic Successful Response
     * @throws ApiError
     */
    public static listRepresentatives(data: RepresentativesListRepresentativesData): CancelablePromise<RepresentativesListRepresentativesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/representatives/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns RepresentativeRead Successful Response
     * @throws ApiError
     */
    public static createRepresentative(data: RepresentativesCreateRepresentativeData): CancelablePromise<RepresentativesCreateRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/representatives/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.representativeId
     * @returns RepresentativeRead Successful Response
     * @throws ApiError
     */
    public static readRepresentative(data: RepresentativesReadRepresentativeData): CancelablePromise<RepresentativesReadRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/representatives/{representative_id}',
            path: {
                organisation_id: data.organisationId,
                representative_id: data.representativeId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.representativeId
     * @param data.requestBody
     * @returns RepresentativeRead Successful Response
     * @throws ApiError
     */
    public static updateRepresentative(data: RepresentativesUpdateRepresentativeData): CancelablePromise<RepresentativesUpdateRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/representatives/{representative_id}',
            path: {
                organisation_id: data.organisationId,
                representative_id: data.representativeId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Representative
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.representativeId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteRepresentative(data: RepresentativesDeleteRepresentativeData): CancelablePromise<RepresentativesDeleteRepresentativeResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/representatives/{representative_id}',
            path: {
                organisation_id: data.organisationId,
                representative_id: data.representativeId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class RfidService {
    /**
     * Execute a raw RFID command directly
     * Sends a raw RFID command based on the RawRFIDCommand object.
     * The endpoint only sends the command to the reader via MQTT.
     * It does not check for successful communication with the reader.
     * The details of the actual command will be found in the command info.
     *
     * - Requires superuser permissions.
     * - Returns the command object.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Command Successful Response
     * @throws ApiError
     */
    public static executeRawRfidCommand(data: RfidExecuteRawRfidCommandData): CancelablePromise<RfidExecuteRawRfidCommandResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/rfid/commands/execute',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: 'Not enough permissions to schedule command',
                404: 'Reader not found',
                422: 'Validation Error',
                500: 'Unable to create command'
            }
        });
    }
    
    /**
     * Create a new RFID command alias
     * Sends a raw RFID command  to create a new alias based on the RawRFIDCommand object.
     * The endpoint only sends the command to the reader via MQTT.
     * It does not check for successful communication with the reader.
     * The details of the actual command will be found in the command info.
     *
     * - Requires superuser permissions.
     * - Returns the command object.
     * @param data The data for the request.
     * @param data.name
     * @param data.definition
     * @param data.readerId
     * @param data.timeout
     * @returns Command Successful Response
     * @throws ApiError
     */
    public static createCommandAlias(data: RfidCreateCommandAliasData): CancelablePromise<RfidCreateCommandAliasResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/rfid/commands/aliases',
            query: {
                name: data.name,
                definition: data.definition,
                reader_id: data.readerId,
                timeout: data.timeout
            },
            errors: {
                403: 'Not enough permissions to schedule command',
                404: 'Reader not found',
                422: 'Validation Error',
                500: 'Unable to create command'
            }
        });
    }
    
    /**
     * List all defined RFID command aliases
     * Sends a raw RFID command to list all aliases based on the RawRFIDCommand object.
     * The endpoint only sends the command to the reader via MQTT.
     * It does not check for successful communication with the reader.
     * The details of the actual command will be found in the command info.
     *
     * - Requires superuser permissions.
     * - Returns the command object.
     * @param data The data for the request.
     * @param data.readerId
     * @param data.timeout
     * @returns Command Successful Response
     * @throws ApiError
     */
    public static listCommandAliases(data: RfidListCommandAliasesData = {}): CancelablePromise<RfidListCommandAliasesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/rfid/commands/aliases',
            query: {
                reader_id: data.readerId,
                timeout: data.timeout
            },
            errors: {
                403: 'Not enough permissions to schedule command',
                404: 'Reader not found',
                422: 'Validation Error',
                500: 'Unable to create command'
            }
        });
    }
    
    /**
     * Delete an existing RFID command alias
     * Sends a raw RFID command to delete the specified alias based on the RawRFIDCommand object.
     * The endpoint only sends the command to the reader via MQTT.
     * It does not check for successful communication with the reader.
     * The details of the actual command will be found in the command info.
     *
     * - Requires superuser permissions.
     * - Returns the command object.
     * @param data The data for the request.
     * @param data.name
     * @param data.readerId
     * @param data.timeout
     * @returns Command Successful Response
     * @throws ApiError
     */
    public static deleteCommandAlias(data: RfidDeleteCommandAliasData): CancelablePromise<RfidDeleteCommandAliasResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/rfid/commands/aliases/{name}',
            path: {
                name: data.name
            },
            query: {
                reader_id: data.readerId,
                timeout: data.timeout
            },
            errors: {
                403: 'Not enough permissions to schedule command',
                404: 'Reader not found',
                422: 'Validation Error',
                500: 'Unable to create command'
            }
        });
    }
    
}

export class SvService {
    /**
     * Two Sv Status
     * @returns TwoSvStatus Successful Response
     * @throws ApiError
     */
    public static twoSvStatus(): CancelablePromise<SvTwoSvStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/2sv/status'
        });
    }
    
    /**
     * Two Sv Setup
     * @returns TwoSvSetupResponse Successful Response
     * @throws ApiError
     */
    public static twoSvSetup(): CancelablePromise<SvTwoSvSetupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/2sv/setup'
        });
    }
    
    /**
     * Two Sv Enable
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TwoSvEnableResponse Successful Response
     * @throws ApiError
     */
    public static twoSvEnable(data: SvTwoSvEnableData): CancelablePromise<SvTwoSvEnableResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/2sv/enable',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Two Sv Disable
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static twoSvDisable(data: SvTwoSvDisableData): CancelablePromise<SvTwoSvDisableResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/2sv/disable',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class TagCategoriesService {
    /**
     * List Tag Categories
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagCategoriesPublic Successful Response
     * @throws ApiError
     */
    public static listTagCategories(data: TagCategoriesListTagCategoriesData): CancelablePromise<TagCategoriesListTagCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagCategoryRead Successful Response
     * @throws ApiError
     */
    public static createTagCategory(data: TagCategoriesCreateTagCategoryData): CancelablePromise<TagCategoriesCreateTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.categoryId
     * @returns TagCategoryRead Successful Response
     * @throws ApiError
     */
    public static readTagCategory(data: TagCategoriesReadTagCategoryData): CancelablePromise<TagCategoriesReadTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/{category_id}',
            path: {
                organisation_id: data.organisationId,
                category_id: data.categoryId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.categoryId
     * @param data.requestBody
     * @returns TagCategoryRead Successful Response
     * @throws ApiError
     */
    public static updateTagCategory(data: TagCategoriesUpdateTagCategoryData): CancelablePromise<TagCategoriesUpdateTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/{category_id}',
            path: {
                organisation_id: data.organisationId,
                category_id: data.categoryId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Tag Category
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.categoryId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteTagCategory(data: TagCategoriesDeleteTagCategoryData): CancelablePromise<TagCategoriesDeleteTagCategoryResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tag-categories/{category_id}',
            path: {
                organisation_id: data.organisationId,
                category_id: data.categoryId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class TagsService {
    /**
     * List all tags
     * Retrieve a paginated list of all tags.
     *
     * - Requires superuser permissions.
     * - Supports pagination via `skip` and `limit` query parameters.
     * @param data The data for the request.
     * @param data.organizationId Filter by organization
     * @param data.skip
     * @param data.limit
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static readTags(data: TagsReadTagsData = {}): CancelablePromise<TagsReadTagsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/',
            query: {
                organization_id: data.organizationId,
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                403: 'Not enough permissions to access this resource',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create a new tag
     * Create a new tag record.
     *
     * - Requires superuser privileges.
     * - Automatically associates the tag with the first organisation the user belongs to.
     * - Returns 400 if the user does not belong to any organisation.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.organisationId Organization to create tag in
     * @returns TagRead Tag successfully created
     * @throws ApiError
     */
    public static createTag(data: TagsCreateTagData): CancelablePromise<TagsCreateTagResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/',
            query: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'User has no organisation',
                403: 'Not enough permissions',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List all tags with pagination and filters (superuser)
     * Get paginated tags across all organizations (superuser only).
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @param data.search
     * @param data.tagType
     * @param data.state
     * @param data.readerId
     * @param data.tagTemplateId
     * @param data.organisationId
     * @param data.sortBy
     * @param data.sortOrder
     * @returns TagsPublic Successful Response
     * @throws ApiError
     */
    public static readTagsPaginated(data: TagsReadTagsPaginatedData = {}): CancelablePromise<TagsReadTagsPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/paginated',
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search,
                tag_type: data.tagType,
                state: data.state,
                reader_id: data.readerId,
                tag_template_id: data.tagTemplateId,
                organisation_id: data.organisationId,
                sort_by: data.sortBy,
                sort_order: data.sortOrder
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get tag by ID
     * Retrieve a single tag by its unique ID.
     *
     * - Requires superuser permissions.
     * - Returns 404 if the tag does not exist.
     * @param data The data for the request.
     * @param data.id The unique ID of the tag to retrieve
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static readTag(data: TagsReadTagData): CancelablePromise<TagsReadTagResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}',
            path: {
                id: data.id
            },
            errors: {
                403: 'Not enough permissions',
                404: 'Tag not found',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Tag
     * Update a tag.
     *
     * Superusers can update any tag.
     * Regular users can only update tags in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static updateTag(data: TagsUpdateTagData): CancelablePromise<TagsUpdateTagResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/tags/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Tag
     * Delete a tag.
     *
     * Superusers can delete any tag.
     * Regular users can only delete tags in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteTag(data: TagsDeleteTagData): CancelablePromise<TagsDeleteTagResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/tags/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Retrieve a list of tag templates
     * Retrieve a paginated list of tag templates.
     *
     * - Requires superuser permissions.
     * - Supports pagination with `skip` and `limit` query parameters.
     * @param data The data for the request.
     * @param data.organizationId Filter by organization
     * @param data.skip
     * @param data.limit
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static readTagTemplates(data: TagsReadTagTemplatesData = {}): CancelablePromise<TagsReadTagTemplatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/templates/',
            query: {
                organization_id: data.organizationId,
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                403: 'Not enough permissions to access this resource',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create a new tag template
     * Create a new tag template.
     *
     * - Requires superuser permissions.
     * - Returns the newly created tag template.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.organisationId Organization to create template in
     * @returns TagTemplateRead Tag template successfully created
     * @throws ApiError
     */
    public static createTagTemplate(data: TagsCreateTagTemplateData): CancelablePromise<TagsCreateTagTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/templates/',
            query: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: 'Not enough permissions to create a tag template',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Tag Template
     * Get tag template by id.
     *
     * Superusers can access any template.
     * Regular users can only access templates in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static readTagTemplate(data: TagsReadTagTemplateData): CancelablePromise<TagsReadTagTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/templates/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Tag Template
     * Update a tag template.
     *
     * Superusers can update any template.
     * Regular users can only update templates in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static updateTagTemplate(data: TagsUpdateTagTemplateData): CancelablePromise<TagsUpdateTagTemplateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/tags/templates/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Tag Template
     * Delete a tag template.
     *
     * Superusers can delete any template.
     * Regular users can only delete templates in their organizations.
     * @param data The data for the request.
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteTagTemplate(data: TagsDeleteTagTemplateData): CancelablePromise<TagsDeleteTagTemplateResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/tags/templates/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create tag from template
     * Create a new tag based on an existing template.
     *
     * - Requires CREATE permission on tags
     * - Inherits tag_type, min_threshold, max_threshold from template
     * - Allows overriding min_threshold and max_threshold
     * - Returns the newly created tag
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns TagRead Tag successfully created from template
     * @throws ApiError
     */
    public static createTagFromTemplate(data: TagsCreateTagFromTemplateData): CancelablePromise<TagsCreateTagFromTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/templates/{id}/tags',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: 'Not enough permissions',
                404: 'Template not found',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get tag readings
     * Retrieve readings for a specific tag.
     *
     * - Requires superuser permissions.
     * - Supports pagination via `skip` and `limit`.
     * - Optionally filter results by time range using `start_time` and `end_time`.
     * - If no time range is provided, returns all readings for the tag within pagination bounds.
     * @param data The data for the request.
     * @param data.id The ID of the tag whose readings to retrieve
     * @param data.skip Number of tag readings to skip for pagination
     * @param data.limit Max number of tag readings to return
     * @param data.startTime Filter readings from this timestamp (inclusive)
     * @param data.endTime Filter readings up to this timestamp (inclusive)
     * @returns TagReadingRead Successful Response
     * @throws ApiError
     */
    public static readTagReadings(data: TagsReadTagReadingsData): CancelablePromise<TagsReadTagReadingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}/readings',
            path: {
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                start_time: data.startTime,
                end_time: data.endTime
            },
            errors: {
                403: 'Not enough permissions to access tag readings',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create a tag reading
     * Create a new reading for a specific tag.
     *
     * - Requires superuser permissions.
     * - The `tag_id` in the path must match the `tag_id` in the request body.
     * - Returns the created tag reading.
     * @param data The data for the request.
     * @param data.id The ID of the tag to create a reading for
     * @param data.requestBody
     * @returns TagReading Successful Response
     * @returns unknown Tag reading successfully created
     * @throws ApiError
     */
    public static createTagReading(data: TagsCreateTagReadingData): CancelablePromise<TagsCreateTagReadingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/{id}/readings',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Tag ID mismatch between path and body',
                403: 'Not enough permissions to create tag reading',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Count Tag Readings
     * Get total reading count for a tag. Lightweight endpoint for progress tracking.
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static countTagReadings(data: TagsCountTagReadingsData): CancelablePromise<TagsCountTagReadingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}/readings/count',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get tag events
     * Retrieve events for a specific tag.
     *
     * - Requires superuser permissions.
     * - Supports pagination via `skip` and `limit`.
     * - Optionally filter results by time range using `start_time` and `end_time`.
     * - If no time range is provided, returns all events for the tag within pagination bounds.
     * @param data The data for the request.
     * @param data.id The ID of the tag whose readings to retrieve
     * @param data.skip Number of tag events to skip for pagination
     * @param data.limit Max number of tag events to return
     * @param data.startTime Filter events from this timestamp (inclusive)
     * @param data.endTime Filter events up to this timestamp (inclusive)
     * @returns TagEventRead Successful Response
     * @throws ApiError
     */
    public static readTagEvents(data: TagsReadTagEventsData): CancelablePromise<TagsReadTagEventsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}/events',
            path: {
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                start_time: data.startTime,
                end_time: data.endTime
            },
            errors: {
                403: 'Not enough permissions to access tag events',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create a tag event
     * Create a new event for a specific tag.
     *
     * - Requires superuser permissions.
     * - The `tag_id` in the path must match the `tag_id` in the event payload.
     * - Returns the created tag event.
     * @param data The data for the request.
     * @param data.id The ID of the tag to create an event for
     * @param data.requestBody
     * @returns TagEventRead Successful Response
     * @throws ApiError
     */
    public static createTagEvent(data: TagsCreateTagEventData): CancelablePromise<TagsCreateTagEventResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/{id}/events',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Tag ID in path does not match the ID in the event body',
                403: 'Not enough permissions to create tag event',
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Per-scan telemetry timeline (temperature / battery_voltage / etc.)
     * Return a ``[{timestamp, value}, …]`` time series of per-scan
     * telemetry pulled from ``tagevent.data->>field``. This is the
     * SCAN-instant feed for the new Instant temp event + Battery voltage
     * tabs on the tag-detail page — distinct from ``tagreading``, which
     * only holds READ-batch (on-chip-memory) temperature logs.
     *
     * Events whose data JSON doesn't carry the requested field are
     * skipped. Sorted ascending by timestamp.
     * @param data The data for the request.
     * @param data.id The ID of the tag whose scan telemetry to retrieve
     * @param data.field Which TagEvent.data field to pull. Allowed: 'temperature', 'battery_voltage', 'rssi', 'on_chip_rssi'.
     * @param data.startTime Filter events from this timestamp (inclusive)
     * @param data.endTime Filter events up to this timestamp (inclusive)
     * @param data.limit Max number of telemetry points to return
     * @returns ScanTelemetryPoint Successful Response
     * @throws ApiError
     */
    public static readTagScanTelemetry(data: TagsReadTagScanTelemetryData): CancelablePromise<TagsReadTagScanTelemetryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}/scan-telemetry',
            path: {
                id: data.id
            },
            query: {
                field: data.field,
                start_time: data.startTime,
                end_time: data.endTime,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get tag alert history
     * Retrieve alert history for a specific tag
     * @param data The data for the request.
     * @param data.id
     * @param data.limit
     * @returns TagAlertRead Successful Response
     * @throws ApiError
     */
    public static readTagAlerts(data: TagsReadTagAlertsData): CancelablePromise<TagsReadTagAlertsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}/alerts',
            path: {
                id: data.id
            },
            query: {
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Acknowledge tag alert
     * Acknowledge an active alert for a tag
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns TagAlertRead Successful Response
     * @throws ApiError
     */
    public static acknowledgeTagAlert(data: TagsAcknowledgeTagAlertData): CancelablePromise<TagsAcknowledgeTagAlertResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/{id}/alerts/acknowledge',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get active alerts
     * Retrieve all active (unresolved) alerts
     * @param data The data for the request.
     * @param data.organizationId
     * @returns TagAlertRead Successful Response
     * @throws ApiError
     */
    public static readActiveAlerts(data: TagsReadActiveAlertsData = {}): CancelablePromise<TagsReadActiveAlertsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/alerts/active',
            query: {
                organization_id: data.organizationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Fetch Tag Info
     * Get detailed information about a tag directly from the RFID tag.
     * @param data The data for the request.
     * @param data.id
     * @param data.readerId
     * @param data.outputFormat
     * @param data.timeout
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static fetchTagInfo(data: TagsFetchTagInfoData): CancelablePromise<TagsFetchTagInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}/fetch_info',
            path: {
                id: data.id
            },
            query: {
                reader_id: data.readerId,
                output_format: data.outputFormat,
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Fetch Tag Data
     * Read tag data directly from the RFID tag.
     * @param data The data for the request.
     * @param data.id
     * @param data.readerId
     * @param data.parser Specify the parser to use (opus or magnus)
     * @param data.limit Maximum number of records to read
     * @param data.offset Starting offset for reading records
     * @param data.outputFormat Output format (json, csv, or table)
     * @param data.timeout Timeout in seconds
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static fetchTagData(data: TagsFetchTagDataData): CancelablePromise<TagsFetchTagDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tags/{id}/fetch_data',
            path: {
                id: data.id
            },
            query: {
                reader_id: data.readerId,
                parser: data.parser,
                limit: data.limit,
                offset: data.offset,
                output_format: data.outputFormat,
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Arm Tag
     * Arm a tag directly through the RFID device.
     * @param data The data for the request.
     * @param data.id
     * @param data.readerId
     * @param data.operation
     * @param data.parser
     * @param data.loggingInterval
     * @param data.delayedStart
     * @param data.samples
     * @param data.led
     * @param data.ledOfftime
     * @param data.ledOntime
     * @param data.fingerspot
     * @param data.fingerspotArm
     * @param data.lowAlarm
     * @param data.highAlarm
     * @param data.lowAlarmCount
     * @param data.highAlarmCount
     * @param data.date
     * @param data.time
     * @param data.outputFormat
     * @param data.timeout
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static armTag(data: TagsArmTagData): CancelablePromise<TagsArmTagResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/{id}/arm',
            path: {
                id: data.id
            },
            query: {
                reader_id: data.readerId,
                operation: data.operation,
                parser: data.parser,
                logging_interval: data.loggingInterval,
                delayed_start: data.delayedStart,
                samples: data.samples,
                led: data.led,
                led_offtime: data.ledOfftime,
                led_ontime: data.ledOntime,
                fingerspot: data.fingerspot,
                fingerspot_arm: data.fingerspotArm,
                low_alarm: data.lowAlarm,
                high_alarm: data.highAlarm,
                low_alarm_count: data.lowAlarmCount,
                high_alarm_count: data.highAlarmCount,
                date: data.date,
                time: data.time,
                output_format: data.outputFormat,
                timeout: data.timeout
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Recalculate reading counts for all tags
     * Recomputes reading_count from the actual tagreading table. Superuser only.
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static recalculateReadingCounts(): CancelablePromise<TagsRecalculateReadingCountsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tags/recalculate-reading-counts',
            errors: {
                403: 'Not enough permissions'
            }
        });
    }
    
    /**
     * Read Organization Tags
     * Get all tags for a specific organization.
     *
     * Requires READ permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationTags(data: TagsReadOrganizationTagsData): CancelablePromise<TagsReadOrganizationTagsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Organization Tag
     * Upsert a tag in the specified organization, keyed on
     * ``(organisation_id, epcid)``.
     *
     * Behaves as an enrichment-aware create rather than a strict insert
     * so QDatDroid re-scans don't hit a UNIQUE constraint violation:
     *
     * * **201 Created**  — no prior row; new tag inserted.
     * * **200 OK**       — existing row was enriched (TID, URL,
     * chip_type, etc. backfilled from blank).
     * * **409 Conflict** — existing row is already complete; the request
     * carried nothing new. The response body is still the existing
     * ``TagRead`` so the caller can flush its stale-cache entry for
     * that EPC.
     *
     * Requires CREATE permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static createOrganizationTag(data: TagsCreateOrganizationTagData): CancelablePromise<TagsCreateOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Organization Tag Trash
     * List soft-deleted tags (trash) for an organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static listOrganizationTagTrash(data: TagsListOrganizationTagTrashData): CancelablePromise<TagsListOrganizationTagTrashResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/trash',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Tags Paginated
     * Get paginated tags for a specific organization with optional filters.
     *
     * Returns data + total count for pagination.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @param data.search Search by name or EPC
     * @param data.tagType Filter by tag type
     * @param data.state Filter by tag state
     * @param data.readerId Filter by reader (last seen by)
     * @param data.parentId Filter by parent tag (children of)
     * @param data.tagTemplateId Filter by the TagTemplate the tag was created from
     * @param data.dppTemplateId Filter by DPP binding: a PassportTemplate UUID limits to tags bound to that template; the literal 'unbound' returns tags with dpp_template_id IS NULL; omit to skip the filter.
     * @param data.sortBy Sort by column
     * @param data.sortOrder Sort order: asc or desc
     * @returns TagsPublic Successful Response
     * @throws ApiError
     */
    public static readOrganizationTagsPaginated(data: TagsReadOrganizationTagsPaginatedData): CancelablePromise<TagsReadOrganizationTagsPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/paginated',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search,
                tag_type: data.tagType,
                state: data.state,
                reader_id: data.readerId,
                parent_id: data.parentId,
                tag_template_id: data.tagTemplateId,
                dpp_template_id: data.dppTemplateId,
                sort_by: data.sortBy,
                sort_order: data.sortOrder
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Tags Map
     * Lightweight tag feed for the map view.
     *
     * Returns only located tags (last_lat/last_lon set) and only the fields the
     * map needs (id, name, epcid, state, position, last seen). This trims the
     * payload dramatically versus the full paginated endpoint, so orgs with 100K+
     * tags load fast. One request — no client-side paging loop.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.limit
     * @returns TagMapPoints Successful Response
     * @throws ApiError
     */
    public static readOrganizationTagsMap(data: TagsReadOrganizationTagsMapData): CancelablePromise<TagsReadOrganizationTagsMapResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/map',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List distinct Tag.category values in this organisation
     * Return the distinct non-null ``Tag.category`` values in use, with the
     * count of tags using each. Drives the category pulldown on the tag
     * form so operators pick from values already in use instead of
     * free-typing duplicates.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static listDistinctTagCategories(data: TagsListDistinctTagCategoriesData): CancelablePromise<TagsListDistinctTagCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/distinct-categories',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List distinct Tag.sku values in this organisation
     * Return the distinct non-null ``Tag.sku`` values in use, with usage
     * counts. Drives the SKU pulldown on the tag form.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static listDistinctTagSkus(data: TagsListDistinctTagSkusData): CancelablePromise<TagsListDistinctTagSkusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/distinct-skus',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get recent tag readings for all tags in organization
     * Get recent tag inventory events across all tags in the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.minutes Look-back window in minutes
     * @param data.limit Max number of results
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getOrganizationRecentActivity(data: TagsGetOrganizationRecentActivityData): CancelablePromise<TagsGetOrganizationRecentActivityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/recent-activity',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                minutes: data.minutes,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get paginated tag events for organization
     * Get paginated events with total count for an organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @param data.minutes Look-back window in minutes
     * @param data.search Search by tag name or EPC
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getOrganizationEventsPaginated(data: TagsGetOrganizationEventsPaginatedData): CancelablePromise<TagsGetOrganizationEventsPaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/events/paginated',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                minutes: data.minutes,
                search: data.search
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get events for a specific tag in an organization
     * Get events for a specific tag, scoped to organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.skip
     * @param data.limit
     * @returns TagEventRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationTagEvents(data: TagsReadOrganizationTagEventsData): CancelablePromise<TagsReadOrganizationTagEventsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/events',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get barcode scans for a specific tag in an organization
     * Get barcode scans for a specific tag (newest first), scoped to org.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.skip
     * @param data.limit
     * @returns TagBarcodeScanRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationTagBarcodeScans(data: TagsReadOrganizationTagBarcodeScansData): CancelablePromise<TagsReadOrganizationTagBarcodeScansResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/barcode-scans',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get multimodal scan bundles anchored to a tag
     * Get multimodal scan bundles anchored to a tag (newest first).
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.skip
     * @param data.limit
     * @returns MultimodalScanRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationTagMultimodalScans(data: TagsReadOrganizationTagMultimodalScansData): CancelablePromise<TagsReadOrganizationTagMultimodalScansResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/multimodal-scans',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get a multimodal scan bundle by its stable scan_id
     * Get a single multimodal bundle by scan_id, scoped to the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.scanId
     * @returns MultimodalScanRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationMultimodalScan(data: TagsReadOrganizationMultimodalScanData): CancelablePromise<TagsReadOrganizationMultimodalScanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/multimodal-scans/{scan_id}',
            path: {
                organisation_id: data.organisationId,
                scan_id: data.scanId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Tag
     * Get a specific tag in an organization.
     *
     * Requires READ permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationTag(data: TagsReadOrganizationTagData): CancelablePromise<TagsReadOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Organization Tag
     * Update a specific tag in an organization.
     *
     * Requires UPDATE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.requestBody
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static updateOrganizationTag(data: TagsUpdateOrganizationTagData): CancelablePromise<TagsUpdateOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Organization Tag
     * Soft-delete a tag (moves it to trash, preserving all historical data).
     *
     * Requires DELETE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteOrganizationTag(data: TagsDeleteOrganizationTagData): CancelablePromise<TagsDeleteOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Upload an image for a tag
     * Upload an image for a tag. Appends to images list.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.formData
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static uploadTagImage(data: TagsUploadTagImageData): CancelablePromise<TagsUploadTagImageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/upload-image',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete a tag image by index
     * Delete an image from a tag's images list by index.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.imageIndex
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteTagImage(data: TagsDeleteTagImageData): CancelablePromise<TagsDeleteTagImageResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/images/{image_index}',
            path: {
                organisation_id: data.organisationId,
                id: data.id,
                image_index: data.imageIndex
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Bulk Delete Organization Tags
     * Soft-delete multiple tags in a single request (moves them to trash).
     *
     * Requires DELETE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static bulkDeleteOrganizationTags(data: TagsBulkDeleteOrganizationTagsData): CancelablePromise<TagsBulkDeleteOrganizationTagsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/bulk-delete',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Restore Organization Tag
     * Restore a soft-deleted tag from trash.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static restoreOrganizationTag(data: TagsRestoreOrganizationTagData): CancelablePromise<TagsRestoreOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/restore',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Bulk Restore Organization Tags
     * Restore multiple soft-deleted tags from trash in a single request.
     *
     * Requires DELETE permission on tags.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static bulkRestoreOrganizationTags(data: TagsBulkRestoreOrganizationTagsData): CancelablePromise<TagsBulkRestoreOrganizationTagsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/bulk-restore',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Permanently Delete Organization Tag
     * Permanently delete a tag and all its data, bypassing the trash.
     *
     * The trash precondition was removed in 2.0.0 — operators can now
     * delete directly from the edit page with a confirmation. Soft-delete
     * via the trash flow is still available for reversible removals; this
     * endpoint is the one-shot "purge everything" path.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static permanentlyDeleteOrganizationTag(data: TagsPermanentlyDeleteOrganizationTagData): CancelablePromise<TagsPermanentlyDeleteOrganizationTagResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/permanent',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get timestamp of the first reading for a tag
     * Return the timestamp of the earliest recorded reading for a tag.
     * Used by the dashboard to set the Grafana time range.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getOrganizationTagFirstReading(data: TagsGetOrganizationTagFirstReadingData): CancelablePromise<TagsGetOrganizationTagFirstReadingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tags/{id}/first-reading',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Set Tag Passport Binding
     * Set, clear, or lock a tag's public passport binding.
     *
     * Body shape: ``{template_id: UUID|null, locked: bool}``.
     *
     * - ``template_id=null`` clears the binding (tag has no public page).
     * - ``locked=true`` prevents the ingester auto-bind hook from
     * overwriting the binding on subsequent SCANs.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.tagId
     * @param data.requestBody
     * @returns TagRead Successful Response
     * @throws ApiError
     */
    public static setTagPassportBinding(data: TagsSetTagPassportBindingData): CancelablePromise<TagsSetTagPassportBindingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tags/{tag_id}/passport-binding',
            path: {
                organisation_id: data.organisationId,
                tag_id: data.tagId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class TagSkusService {
    /**
     * List Tag Skus
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagSkuCatalogPublic Successful Response
     * @throws ApiError
     */
    public static listTagSkus(data: TagSkUsListTagSkusData): CancelablePromise<TagSkUsListTagSkusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagSkuCatalogRead Successful Response
     * @throws ApiError
     */
    public static createTagSku(data: TagSkUsCreateTagSkuData): CancelablePromise<TagSkUsCreateTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skuId
     * @returns TagSkuCatalogRead Successful Response
     * @throws ApiError
     */
    public static readTagSku(data: TagSkUsReadTagSkuData): CancelablePromise<TagSkUsReadTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/{sku_id}',
            path: {
                organisation_id: data.organisationId,
                sku_id: data.skuId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skuId
     * @param data.requestBody
     * @returns TagSkuCatalogRead Successful Response
     * @throws ApiError
     */
    public static updateTagSku(data: TagSkUsUpdateTagSkuData): CancelablePromise<TagSkUsUpdateTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/{sku_id}',
            path: {
                organisation_id: data.organisationId,
                sku_id: data.skuId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Tag Sku
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skuId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteTagSku(data: TagSkUsDeleteTagSkuData): CancelablePromise<TagSkUsDeleteTagSkuResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tag-skus-catalog/{sku_id}',
            path: {
                organisation_id: data.organisationId,
                sku_id: data.skuId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class TagTemplatesService {
    /**
     * Read Organization Templates
     * Get all tag templates for a specific organization.
     *
     * Requires READ permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationTemplates(data: TagTemplatesReadOrganizationTemplatesData): CancelablePromise<TagTemplatesReadOrganizationTemplatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Organization Template
     * Create a new tag template in the specified organization.
     *
     * Requires CREATE permission on the organization.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.requestBody
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static createOrganizationTemplate(data: TagTemplatesCreateOrganizationTemplateData): CancelablePromise<TagTemplatesCreateOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/',
            path: {
                organisation_id: data.organisationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List chip_type values selectable for templates (catalog + observed)
     * Return the union of:
     *
     * 1. The bundled QDatDroid identifier catalog (``tag_type`` +
     * ``chip_manufacturer`` + ``cin_brand`` + ``nfc_ic_manufacturer`` —
     * see ``app/data/qdat-io-tag-types.json``); and
     * 2. The distinct ``chip_type`` values currently observed on this org's
     * tag table (catches any operator-typed or vendor-emitted value not
     * yet in the catalog).
     *
     * The result populates the chip_type combobox in the template editor so
     * an operator can pre-create a template for any identifier QDatDroid
     * might emit — even before a tag of that type has been scanned.
     * @param data The data for the request.
     * @param data.organisationId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static listObservedChipTypes(data: TagTemplatesListObservedChipTypesData): CancelablePromise<TagTemplatesListObservedChipTypesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/observed-chip-types',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Full QDatDroid identifier catalog grouped by category
     * Return the bundled catalog (``app/data/qdat-io-tag-types.json``)
     * grouped by identifier category, along with the binding-field priority
     * order used by the ingester. Frontend uses this to render a richer
     * typeahead grouped by category (tag_type → chip_manufacturer →
     * cin_brand → nfc_ic_manufacturer).
     * @param data The data for the request.
     * @param data.organisationId
     * @returns TagCatalogResponse Successful Response
     * @throws ApiError
     */
    public static getTagCatalog(data: TagTemplatesGetTagCatalogData): CancelablePromise<TagTemplatesGetTagCatalogResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/catalog',
            path: {
                organisation_id: data.organisationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Organization Template
     * Get a specific tag template in an organization.
     *
     * Requires READ permission on tag templates.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static readOrganizationTemplate(data: TagTemplatesReadOrganizationTemplateData): CancelablePromise<TagTemplatesReadOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Organization Template
     * Update a specific tag template in an organization.
     *
     * Requires UPDATE permission on tag templates.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @param data.requestBody
     * @returns TagTemplateRead Successful Response
     * @throws ApiError
     */
    public static updateOrganizationTemplate(data: TagTemplatesUpdateOrganizationTemplateData): CancelablePromise<TagTemplatesUpdateOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Organization Template
     * Delete a tag template, cascading any bound tags onto the org's Default.
     *
     * The Default template (``is_default=True``) is protected — attempting
     * to delete it returns 400. For every other template, this handler:
     *
     * 1. Looks up the org's Default template.
     * 2. Re-points all ``tag.tag_template_id`` rows that referenced the
     * deleted template to the Default (also updates ``tag.tag_type`` so
     * tag and template stay consistent).
     * 3. Deletes the template.
     *
     * Requires DELETE permission on tag templates.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteOrganizationTemplate(data: TagTemplatesDeleteOrganizationTemplateData): CancelablePromise<TagTemplatesDeleteOrganizationTemplateResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{organisation_id}/tag-templates/{id}',
            path: {
                organisation_id: data.organisationId,
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class UploadsService {
    /**
     * Serve Upload
     * Serve an uploaded file by its relative path.
     * @param data The data for the request.
     * @param data.path
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static serveUpload(data: UploadsServeUploadData): CancelablePromise<UploadsServeUploadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/uploads/{path}',
            path: {
                path: data.path
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class UsersService {
    /**
     * Read User Me
     * Get current user.
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static readUserMe(): CancelablePromise<UsersReadUserMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/me'
        });
    }
    
    /**
     * Delete User Me
     * Delete own user.
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteUserMe(): CancelablePromise<UsersDeleteUserMeResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/users/me'
        });
    }
    
    /**
     * Update User Me
     * Update own user.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static updateUserMe(data: UsersUpdateUserMeData): CancelablePromise<UsersUpdateUserMeResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/users/me',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Password Me
     * Update own password.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static updatePasswordMe(data: UsersUpdatePasswordMeData): CancelablePromise<UsersUpdatePasswordMeResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/users/me/password',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Register User
     * Create new user without the need to be logged in.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static registerUser(data: UsersRegisterUserData): CancelablePromise<UsersRegisterUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/users/signup',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create User
     * Create new user. Only superusers can create users.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static createUser(data: UsersCreateUserData): CancelablePromise<UsersCreateUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/users/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Users
     * Retrieve users.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns UsersPublic Successful Response
     * @throws ApiError
     */
    public static readUsers(data: UsersReadUsersData = {}): CancelablePromise<UsersReadUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read User
     * Get a specific user by id.
     *
     * Users can always read their own profile.
     * Only superusers can read other users' profiles.
     * @param data The data for the request.
     * @param data.id
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static readUser(data: UsersReadUserData): CancelablePromise<UsersReadUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update User
     * Update a user. Only superusers can update other users.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static updateUser(data: UsersUpdateUserData): CancelablePromise<UsersUpdateUserResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/users/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete User
     * Delete a user. Only superusers can delete other users.
     * @param data The data for the request.
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteUser(data: UsersDeleteUserData): CancelablePromise<UsersDeleteUserResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/users/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List users in an organisation
     * Return all users that belong to the given organisation via the OrganisationUsers M2M link. Requires READ on USER.
     * @param data The data for the request.
     * @param data.organisationId
     * @param data.skip
     * @param data.limit
     * @returns UsersPublic Successful Response
     * @throws ApiError
     */
    public static readOrganizationUsers(data: UsersReadOrganizationUsersData): CancelablePromise<UsersReadOrganizationUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{organisation_id}/users/',
            path: {
                organisation_id: data.organisationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}